{
  "InteractiveBookOptionalFilters": "Optionally narrow units by certificate and course, or search units directly by name or rank.",
  "InteractiveBookCertificateFilter": "Certificate (optional)",
  "InteractiveBookCourseFilter": "Course (optional)",
  "InteractiveBookLinkedUnit": "Linked LMS unit",
  "InteractiveBookLinkedTopic": "Linked LMS topic",
  "InteractiveBookSearchNameRank": "Search by name or rank",
  "InteractiveBookLinkParentFirst": "Select and save the chapter’s LMS unit before linking its topics.",
  "InteractiveBookUnitRequired": "Select a valid LMS unit for this chapter.",
  "InteractiveBookTopicRequired": "Select a topic belonging to the chapter’s linked LMS unit.",
  "InteractiveBookUnitChangeConfirmation": "Changing this chapter’s LMS unit will clear its section topic links. Section content will be preserved. Continue and select new topics afterward?",
  "InteractiveBookLinkLoadError": "LMS options could not be loaded. Change the search to retry.",
  "InteractiveBookRefineSearch": "Showing the first 100 matches. Refine your search to find more specific results.",
  "translations": {
    "PackageProperties": "Package properties",
    "PackageProperty": "Property",
    "PackagePropertyValue": "Value",
    "PackagePropertiesApiUnavailable": "Package properties could not be loaded. Check that the configured backend has the package properties update and migration installed, then retry.",
    "PackagePropertiesRetry": "Retry",
    "PackagePropertyTypeBOOLEAN": "True / False",
    "PackagePropertyTypeNUMBER": "Number",
    "PackagePropertyTypeTEXT": "Text",
    "PackagePropertyTypeLocked": "A property used by packages keeps its type. Remove its assignments before changing its type or deleting it, or deactivate it to hide it from students.",
    "PackagePropertyDuplicate": "This property is already selected for this package.",
    "ComparePackages": "Compare packages",
    "SelectPackageToCompare": "Compare {{name}}",
    "BookDocumentJson": "Interactive Book package (.json)",
    "BookDocumentWord": "Import Word document (.docx)",
    "BookDocumentPdf": "Import PDF document (.pdf)",
    "BookDocumentDraftHint": "Review the conversion before creating an unpublished draft. Add course links and finish editing in the book editor.",
    "BookDocumentFile": "Source document",
    "BookDocumentWordLimit": "DOCX only, up to 25 MB. Save older .doc files as .docx first. Page layout may change.",
    "BookDocumentPdfLimit": "Up to 50 MB and 150 selected pages. Leave the page range unchanged to import the entire PDF.",
    "BookDocumentTitle": "Book title",
    "BookDocumentLanguage": "Destination content language",
    "BookDocumentArabic": "Arabic",
    "BookDocumentEnglish": "English",
    "BookDocumentSplit": "Chapter and section structure",
    "BookDocumentSplit_headings": "Propose chapters and sections from headings",
    "BookDocumentSplit_single": "One chapter and one section",
    "BookDocumentSplit_pages": "One section per PDF page",
    "BookDocumentFromPage": "First page",
    "BookDocumentToPage": "Last page",
    "BookDocumentLastPage": "End of document",
    "BookDocumentMode": "PDF conversion mode",
    "BookDocumentMode_text": "Editable text only",
    "BookDocumentMode_images": "Original PDF pages (styles and images)",
    "BookDocumentModeHint_images": "Import complete PDF pages as high-resolution images, preserving fonts, colors, pictures, tables, diagrams and page layout. Text and objects within each page are not individually editable.",
    "BookDocumentModeHint_text": "Extract editable text and headings. Original styles, pictures and page layout are not included. Choose Original PDF pages to preserve the whole page.",
    "BookDocumentAnalyzing": "Analyzing document: {{completed}} / {{total}}",
    "BookDocumentAnalyze": "Analyze and preview",
    "BookDocumentCover": "Cover image",
    "BookDocumentNoCover": "No cover",
    "BookDocumentImage": "Image",
    "BookDocumentPage": "Page",
    "BookDocumentWarnings": "Review these conversion warnings",
    "BookDocumentPages": "Source pages and image fallback",
    "BookDocumentPreviewPage": "Preview page",
    "BookDocumentPdfTags": "PDF heading tags could not be read. The extracted text is preserved; review the proposed headings.",
    "BookDocumentPdfWorkerError": "The PDF converter could not start or stopped unexpectedly. Reload the page and try again.",
    "BookDocumentErrorDetails": "Error details",
    "BookDocumentDiagnosticsHint": "Copy this log, or filter the browser console by [Book {{kind}} import].",
    "BookDocumentWordWorkerError": "The Word converter could not start or stopped unexpectedly. Reload the page and try again. Error details identify the failure.",
    "BookDocumentWordConversionError": "Word conversion failed. Open Error details to see where it stopped.",
    "BookDocumentStage_word_read": "Reading the Word file",
    "BookDocumentStage_word_worker": "Starting the Word converter",
    "BookDocumentStage_word_archive": "Checking the Word document structure",
    "BookDocumentStage_word_convert": "Converting Word text, tables and images",
    "BookDocumentStage_word_content": "Preparing content for the book editor",
    "BookDocumentStage_worker": "Starting the PDF converter",
    "BookDocumentStage_open": "Reading the PDF structure and page count",
    "BookDocumentStage_page": "Loading the source page",
    "BookDocumentStage_text": "Extracting editable text",
    "BookDocumentStage_tags": "Reading PDF heading tags",
    "BookDocumentStage_render": "Rendering the page image",
    "BookDocumentPageChangeHint": "Changing a page's mode rebuilds the proposed structure and resets manual structure edits. Apply page choices before renaming or rearranging sections.",
    "BookDocumentIncludeChapter": "Include chapter",
    "BookDocumentIncludeSection": "Include section",
    "BookDocumentMoveUp": "Move up",
    "BookDocumentMoveDown": "Move down",
    "BookDocumentDemote": "Merge into previous chapter",
    "BookDocumentPromote": "Make a new chapter",
    "BookDocumentPreview": "Preview",
    "BookDocumentMergeNext": "Merge next section",
    "BookDocumentBlocks": "Include content and split sections",
    "BookDocumentSplitHere": "Split before this block",
    "BookDocumentChooseSection": "Select a section to preview its content.",
    "BookDocumentSummary": "{{chapters}} chapters · {{sections}} sections · {{images}} images · approximately {{megabytes}} MB",
    "BookDocumentAcknowledge": "I reviewed the warnings and the content included in this draft.",
    "BookDocumentBack": "Back to conversion options",
    "BookDocumentCreateDraft": "Create unpublished draft",
    "BookDocumentInvalidFile": "Choose a valid document matching the selected file type.",
    "BookDocumentLimit": "The document exceeds the import limits. Select fewer pages or use a smaller document.",
    "BookDocumentUnsupportedWord": "This Word format is unsupported. Save a standard .docx file without macros or encryption.",
    "BookDocumentTimeout": "Conversion took too long. Select fewer pages or simplify the document and try again.",
    "BookDocumentEmpty": "No content remains to import. Include at least one section with content.",
    "BookDocumentPageRange": "Select a valid page range of at most 150 pages within this PDF.",
    "BookDocumentEncrypted": "Password-protected PDFs are not supported. Import an unprotected copy.",
    "BookDocumentTitleRequired": "Every included book, chapter and section needs a title of at most 255 characters.",
    "BookDocumentInvalidContent": "Some converted content is invalid. Review the document or try preserving PDF pages as images.",
    "BookDocumentExternalResources": "External document references were not fetched. Review linked images and resources.",
    "BookDocumentTrackedChanges": "The Word document contains tracked changes. Insertions are retained and deletions are omitted; review the resulting text.",
    "BookDocumentWordStories": "Header and footer text and images were included once near their source section. Repeated page headers, watermark placement and automatic page numbering may change.",
    "BookDocumentWordStoryMissing": "A referenced Word header or footer could not be found in the document. Review its source content.",
    "BookDocumentUnsupportedObjects": "Equations, drawings or embedded objects may lose layout or content. Review them against the original.",
    "BookDocumentUnsupportedImage": "An image format could not be imported. Its alternative text is retained when available.",
    "BookDocumentSanitized": "Unsupported HTML or attributes were removed from the converted document.",
    "BookDocumentUnsafeLink": "An unsupported or unsafe link was removed; its text was retained.",
    "BookDocumentNoteFormatting": "Superscript, subscript or note references were kept as ordinary text.",
    "BookDocumentTableFallback": "A complex table was preserved as text. Review its cell order.",
    "BookDocumentConversionWarning": "Word conversion warning",
    "BookDocumentScannedPage": "This page has no usable text layer and was preserved as an image.",
    "BookDocumentComplexPage": "This page may contain columns or unusual spacing. Check reading order or preserve it as an image.",
    "BookDocumentMixedDirection": "This page mixes Arabic and English. Check word order, letters and numbers against its page image; preserve the page as an image if extraction is inaccurate.",
    "BookDocumentPdfReview": "PDF conversion proposes editable text and headings. Check diagrams, tables, repeated headers and Arabic/English reading order against the original page images.",
    "BookDocumentSubmitError": "The server rejected the import. Your proposal is retained for correction or retry.",
    "BookDocumentSubmitUnknown": "The import outcome could not be confirmed. Check the book library before retrying to avoid creating a duplicate.",
        "BookKnowledgeDescription": "Check your understanding of this topic.",
        "BookKnowledgeUnavailable": "No knowledge tests are available for this topic under your current subscription.",
        "BookKnowledgeQuestions": "{{count}} questions",
        "BookKnowledgeProgress": "Exam progress: {{percent}}%",
        "BookKnowledgeLatestResult": "Latest result",
        "BookKnowledgeScore": "{{score}} / {{total}}",
        "BookKnowledgeNotTaken": "You have not completed this test yet.",
        "BookKnowledgeStart": "Start your knowledge test",
        "BookKnowledgeReview": "Review your attempt",
        "BookKnowledgeOpenError": "Could not open this test. Please try again.",
        "BookChapterTests": "Knowledge tests: {{title}}",
        "BookAudio": "Voice note",
        "BookAudioAdd": "Add a voice note",
        "BookAudioEdit": "Edit voice note",
        "BookAudioTitle": "Title (optional)",
        "BookAudioDescription": "Description (optional)",
        "BookAudioRecord": "Record voice",
        "BookAudioStopRecording": "Stop recording",
        "BookAudioUpload": "Upload audio",
        "BookAudioInsert": "Use this audio",
        "BookAudioRequesting": "Waiting for microphone permission…",
        "BookAudioPreparing": "Preparing your recording…",
        "BookAudioRecording": "Recording",
        "BookAudioLimits": "MP3, WAV, OGG, WebM or M4A · up to 25 MB. Direct recordings: up to 10 minutes.",
        "BookAudioSaveHint": "Save the section to upload the audio and keep this voice note.",
        "BookAudioPlay": "Play voice note",
        "BookAudioPause": "Pause voice note",
        "BookAudioSeek": "Audio position",
        "BookAudioRestart": "Restart audio",
        "BookAudioForward": "Skip forward 10 seconds",
        "BookAudioSpeed": "Playback speed: {{speed}}x",
        "BookAudioMute": "Mute",
        "BookAudioUnmute": "Unmute",
        "BookAudioPlayError": "This recording could not be played. Try again or check your connection.",
        "BookAudioPermission": "Microphone access was denied. Allow it in your browser settings or upload an audio file.",
        "BookAudioUnsupported": "Recording needs a supported browser and HTTPS (or localhost). You can upload an audio file instead.",
        "BookAudioRecordError": "Could not record from the microphone. Check the device and try again.",
        "BookAudioInvalidType": "Choose a valid MP3, WAV, OGG, WebM or M4A audio file.",
        "BookAudioEmpty": "The audio file is empty. Record again or choose another file.",
        "BookAudioTooLarge": "Audio files must be no larger than 25 MB.",
        "BookAudioTooMany": "You can upload up to 10 audio files when saving a section.",
        "BookAudioMappingInvalid": "An audio file is missing. Select or record it again before saving.",
        "BookMediaUploadError": "Could not upload the media. Check the files and try again.",
        "BookKnowledgeReadFirst": "Read all book sections for this topic to unlock the test.",
        "BookKnowledgeReadTopic": "Read topic",
        "BookNoAccessibleSections": "No book sections are available under your current subscription.",
        "BookRemoveCourseLink": "Remove course link",
        "BookRemoveCourseConfirmation": "Remove this course link? Students will no longer access this book through this course. Saved progress and notes will be retained.",
        "BookChangeCourseHint": "Changing the course clears the unit/topic selections. Map them to the new course before saving. Student records remain with their original course.",
        "BookCourseRemoveError": "Could not remove the course link. Please try again.",
        "BookCourseLinkNotFound": "This course link no longer exists. Reload the book.",
    "BookAnnotationFilters": "Filters",
    "BookFilterChapter": "Chapter",
    "BookFilterSection": "Section",
    "BookFilterAllChapters": "All chapters",
    "BookFilterAllSections": "All sections",
    "BookFilterNoteType": "Note type / tag",
    "BookFilterAllTypes": "All types",
    "BookFilterTime": "Last edited",
    "BookFilterTime_all": "All time",
    "BookFilterTime_today": "Today",
    "BookFilterTime_week": "Last 7 days",
    "BookFilterTime_month": "Last 30 days",
    "BookFilterTime_custom": "Custom date and time",
    "BookFilterFrom": "From",
    "BookFilterTo": "To",
    "BookFilterInvalidRange": "The end must be on or after the start.",
    "BookFilterSort": "Sort by",
    "BookFilterSort_newest": "Newest first",
    "BookFilterSort_oldest": "Oldest first",
    "BookFilterSort_chapter": "Chapter name",
    "BookFilterSort_section": "Section name",
    "BookFilterSort_page": "Book page order",
    "BookFilterSort_color": "Color",
    "BookFilterAllColors": "All colors",
    "BookFilterReset": "Reset",
    "BookFilterApply": "Apply filters",
    "BookFiltersNoResults": "No saved items match your search and filters.",
    "BookAddBookmark": "Add bookmark",
    "BookBookmarkCurrentSection": "Current section",
    "BookBookmarkAlreadySaved": "Current section bookmarked",
    "BookBookmarksLoading": "Loading bookmarks…",
    "BookBookmarksEmpty": "No bookmarks yet. Bookmark the current section to return to it later.",
    "BookBookmarksLoadError": "Could not load bookmarks. Please try again.",
    "BookBookmarksSaveError": "Could not save your bookmark changes. Please try again.",
    "BookBookmarkUnavailable": "Section unavailable",
    "BookOpenBookmark": "Open {{title}}, page {{page}}",
    "BookDeleteBookmark": "Delete bookmark: {{title}}",
    "BookRemoveHighlight": "Remove highlight",
    "EditorSpaceBefore": "Space above (px)",
    "EditorSpaceAfter": "Space below (px)",
    "EditorSpacingDefault": "Default",
    "EditorTwoColumns": "2 columns",
    "EditorThreeColumns": "3 columns",
    "EditorColumnSectionStyle": "Column section",
    "EditorColumnSectionBackground": "Section background",
    "EditorColumnSectionPadding": "Section padding (px)",
    "EditorColumnSectionRadius": "Section corner radius (px)",
    "EditorResetColumnSectionStyle": "Reset section style",
    "EditorColumnStyle": "Selected card",
    "EditorColumnCount": "Number of columns",
    "EditorColumnBackground": "Card background",
    "EditorColumnBorder": "Card border color",
    "EditorColumnBorderWidth": "Border width (px)",
    "EditorColumnRadius": "Corner radius (px)",
    "EditorColumnPadding": "Padding (px)",
    "EditorResetColumnStyle": "Reset card style",
    "EditorUnwrapColumns": "Convert to stacked blocks",
    "EditorColumnCountHint": "Changing from 3 to 2 columns moves the third card’s content into the second.",
    "EditorApplyColor": "Apply color",
    "EditorIncreaseIndent": "Increase indent",
    "EditorDecreaseIndent": "Decrease indent",
    "BookAnnotationCopyError": "Could not copy the text. Please select and copy it manually.",
    "BookSelectionActions": "Selected text",
    "BookHighlightAction": "Highlight",
    "BookNoteAction": "Note",
    "BookHighlightColor": "Highlight color",
    "BookNoteColor": "Note color",
    "BookSavedNotes": "Saved notes",
    "BookSavedHighlights": "Saved highlights",
    "BookNewNote": "Add a new note",
    "BookEditNote": "Edit note",
    "BookEditHighlight": "Edit highlight",
    "BookNoteTitle": "Title",
    "BookNoteTitlePlaceholder": "Enter a note title…",
    "BookNoteText": "Text",
    "BookNoteTextPlaceholder": "Write your notes in detail…",
    "BookNoteTags": "Tags",
    "BookAddTag": "+ Add tag",
    "BookSaveNote": "Save note",
    "BookTagExam": "Exam priority",
    "BookTagSummary": "Summary",
    "BookTagDefinition": "Definition",
    "BookTagFormula": "Formula",
    "BookTagExample": "Example",
    "BookAnnotationCopy": "Copy",
    "BookAnnotationCopied": "Copied",
    "BookAnnotationOpen": "Open reader",
    "BookAnnotationDeleteConfirm": "Delete this saved annotation?",
    "BookAnnotationSaving": "Saving…",
    "BookAnnotationsLoading": "Loading your annotations…",
    "BookAnnotationsEmpty": "No saved annotations found. Select text in the book to add one.",
    "BookAnnotationsSearch": "Search saved annotations…",
    "BookAnnotationsSelectHint": "Select a passage in the book to highlight it or add a note.",
    "BookAnnotationsLoadError": "Your annotations could not be loaded. Try again.",
    "BookAnnotationsSaveError": "The change could not be saved. Your annotation is still here; try again.",
    "BookAnnotationInvalid": "The annotation could not be saved. The passage may have changed; reopen the book and select it again.",
    "BookAnnotationColor0": "Yellow",
    "BookAnnotationColor1": "Green",
    "BookAnnotationColor2": "Blue",
    "BookAnnotationColor3": "Pink",
    "BookAnnotationColor4": "Purple",
    "BookAnnotationColor5": "Orange",
    "?": "?",
    "InteractiveBook": "Book",
    "BookContents": "Book contents",
    "BookChapterCount": "Chapters: {{count}}",
    "BookPageCount": "Pages: {{count}}",
    "BookPagePosition": "Page {{current}} of {{total}}",
    "BookStudyTools": "Study tools",
    "BookSearch": "Search this book",
    "BookSearchPrompt": "Search book pages",
    "BookSearchPlaceholder": "Search for a word or concept...",
    "BookSearchHint": "Enter a word to search across all book pages",
    "BookSearchResults": "Matching pages: {{count}}",
    "BookSearchEmpty": "No matching pages found.",
    "BookSearchMore": "Show more results",
    "BookHighlights": "Highlights",
    "BookNotes": "Notes",
    "BookBookmarks": "Bookmarks",
    "BookAddHighlight": "Add highlight",
    "BookAddNote": "Add note",
    "BookAssistant": "Study assistant",
    "BookToolUnavailable": "Not available yet",
    "BookPagesOpened": "Opened {{opened}} of {{total}} pages",
    "BookToggleChapter": "Expand or collapse {{title}}",
    "BookExpandPages": "Expand pages",
    "BookCollapsePages": "Collapse pages",
    "BookVisitProgressHint": "Pages opened during this visit",
    "ChapterReadingTimeMinutes": "Reading time (minutes)",
    "ChapterReadingTimeOptional": "Optional — leave blank to hide",
    "ChapterReadingTime": "{{minutes}} min read",
    "InteractiveBookReadingTimeInvalid": "Enter a whole number of minutes between 1 and 65535, or leave it blank.",
    "InteractiveBookAdmin": "Interactive Book",
    "InteractiveBookAdminDescription": "Create interactive books for every student.",
    "NewInteractiveBook": "New Interactive Book",
    "InteractiveBookLibrary": "Interactive Book Library",
    "Published": "Published",
    "Draft": "Draft",
    "CoverImageUrl": "Cover image URL",
    "BookCoverImage": "Book cover image",
    "BookChooseCoverImage": "Choose image",
    "BookReplaceCoverImage": "Replace image",
    "BookRemoveCoverImage": "Remove image",
    "BookCoverImageHint": "JPEG, PNG, WebP, or GIF. Maximum size 15 MB.",
    "PublishedForStudents": "Published for students",
    "SelectOrCreateInteractiveBook": "Select a book or create a new one.",
    "InteractiveBookLoadError": "The book could not be loaded.",
    "InteractiveBookSaveError": "The book could not be saved.",
    "InteractiveBookDeleteError": "The book could not be deleted.",
    "InteractiveBookTitleRequired": "Add at least an English or Arabic title.",
    "NoInteractiveBook": "No interactive books have been created yet.",
    "InteractiveBookStudentDescription": "Explore books and learning materials.",
    "NoPublishedInteractiveBook": "No published books are available yet.",
    "Retry": "Retry",
    "BackToInteractiveBook": "Back to books",
    "EditorFormatting": "Text formatting",
    "EditorMoreTools": "More editor tools",
    "EditorBlockTools": "Blocks",
    "EditorMediaTools": "Media",
    "EditorBlocks": "Content blocks",
    "EditorAddBlock": "Add block",
    "EditorCurrentBlock": "Current block",
    "EditorParagraph": "Paragraph",
    "EditorHeading1": "Heading 1",
    "EditorHeading2": "Heading 2",
    "EditorHeading3": "Heading 3",
    "EditorBold": "Bold",
    "EditorItalic": "Italic",
    "EditorUnderline": "Underline",
    "EditorStrike": "Strikethrough",
    "EditorHighlight": "Highlight",
    "EditorInlineCode": "Inline code",
    "EditorBulletList": "Bulleted list",
    "EditorOrderedList": "Numbered list",
    "EditorQuote": "Quote",
    "EditorQuoteColor": "Quote color",
    "EditorQuoteBackground": "Quote background",
    "EditorCodeBlock": "Code block",
    "EditorDivider": "Divider",
    "EditorHardBreak": "Line break",
    "EditorAlignLeft": "Align left",
    "EditorAlignCenter": "Align center",
    "EditorAlignRight": "Align right",
    "EditorJustify": "Justify",
    "EditorLink": "Add or edit link",
    "EditorRemoveLink": "Remove link",
    "EditorImage": "Insert image at cursor",
    "EditorImageFromUrl": "Insert image from URL",
    "EditorUploadImage": "Upload image from device",
    "EditorUploadImageBlock": "Upload image block",
    "EditorAlignImageLeft": "Align selected image left",
    "EditorAlignImageCenter": "Center selected image",
    "EditorAlignImageRight": "Align selected image right",
    "EditorFitImageWidth": "Fit selected image to content width",
    "EditorResetImageSize": "Reset selected image to its original size",
    "EditorTableTools": "Table tools",
    "EditorTable": "Table",
    "EditorTableGeneral": "General",
    "EditorTableStructure": "Columns, rows, headers and cells",
    "EditorTableColumns": "Columns",
    "EditorTableRows": "Rows",
    "EditorTableHeaders": "Headers",
    "EditorTableCells": "Cells",
    "EditorTableAppearance": "Whole table appearance",
    "EditorTableRowAppearance": "Current row appearance",
    "EditorTableCellAppearance": "Selected cells appearance",
    "EditorInsertTable": "Insert a 3 by 3 table",
    "EditorAddColumnBefore": "Add column before",
    "EditorAddColumnAfter": "Add column after",
    "EditorDeleteColumn": "Delete current column",
    "EditorAddRowBefore": "Add row before",
    "EditorAddRowAfter": "Add row after",
    "EditorDeleteRow": "Delete current row",
    "EditorToggleHeaderRow": "Toggle header row",
    "EditorToggleHeaderColumn": "Toggle header column",
    "EditorToggleHeaderCell": "Toggle selected header cell",
    "EditorMergeCells": "Merge selected cells",
    "EditorSplitCell": "Split current cell",
    "EditorTableBackground": "Table background",
    "EditorClearTableBackground": "Restore default table background",
    "EditorTableRowBackground": "Current row background",
    "EditorClearTableRowBackground": "Use the table background for this row",
    "EditorTableCellBackground": "Selected cell background",
    "EditorClearTableCellBackground": "Use the table background for selected cells",
    "EditorTableBorders": "Table borders",
    "EditorHideTableBorders": "Hide borders",
    "EditorShowTableBorders": "Show borders",
    "EditorTableBorderColor": "Table border color",
    "EditorTableBorderWidth": "Table border width",
    "EditorTableBorderStyle": "Table border style",
    "EditorTableBorderReset": "Reset table border",
    "EditorRowBorderColor": "Current row border color",
    "EditorRowBorderWidth": "Current row border width",
    "EditorRowBorderStyle": "Current row border style",
    "EditorRowBorderReset": "Use table borders for this row",
    "EditorCellBorderColor": "Selected cell border color",
    "EditorCellBorderWidth": "Selected cell border width",
    "EditorCellBorderStyle": "Selected cell border style",
    "EditorCellBorderReset": "Use row or table borders for selected cells",
    "EditorAlignTableLeft": "Align table left",
    "EditorAlignTableCenter": "Align table center",
    "EditorAlignTableRight": "Align table right",
    "EditorDeleteTable": "Delete table",
    "EditorWatermarkTools": "Watermark tools",
    "EditorWatermark": "Watermark",
    "EditorPageWatermarkTitle": "Content page watermark",
    "EditorPageWatermarkText": "Page watermark text",
    "EditorPageWatermarkUpload": "Upload page watermark image",
    "EditorPageWatermarkImage": "Page watermark image",
    "EditorPageWatermarkRemoveImage": "Remove page watermark image",
    "EditorPageWatermarkColor": "Page watermark text color",
    "EditorPageWatermarkOpacity": "Page watermark opacity",
    "EditorPageWatermarkSize": "Page watermark size",
    "EditorPageWatermarkRotation": "Page watermark rotation",
    "EditorPageWatermarkClear": "Clear page watermark",
    "EditorSectionWatermarkTitle": "Current two/three-card section watermark",
    "EditorSectionWatermarkText": "Section watermark text",
    "EditorSectionWatermarkUpload": "Upload section watermark image",
    "EditorSectionWatermarkImage": "Section watermark image",
    "EditorSectionWatermarkRemoveImage": "Remove section watermark image",
    "EditorSectionWatermarkColor": "Section watermark text color",
    "EditorSectionWatermarkOpacity": "Section watermark opacity",
    "EditorSectionWatermarkSize": "Section watermark size",
    "EditorSectionWatermarkRotation": "Section watermark rotation",
    "EditorSectionWatermarkClear": "Use the page watermark for this section",
    "EditorWatermarkInherited": "This section currently uses the page watermark.",
    "EditorWatermarkSelectSection": "Place the cursor inside a two/three-card section to give it its own watermark.",
    "EditorIconTools": "Icon tools",
    "EditorIcons": "Icons",
    "EditorChooseIcon": "Choose an icon",
    "EditorIconColor": "Icon color",
    "EditorIconSize": "Icon size",
    "EditorInsertIcon": "Insert icon at cursor",
    "EditorUpdateSelectedIcon": "Update selected icon",
    "EditorRemoveSelectedIcon": "Remove selected icon",
    "EditorApplyIconToBullet": "Apply bullet style and color",
    "EditorRemoveCustomBullet": "Reset bullet style and color",
    "EditorIconCheck": "Check",
    "EditorIconCross": "Cross",
    "EditorIconInfo": "Information",
    "EditorIconWarning": "Warning",
    "EditorIconLightbulb": "Idea",
    "EditorIconBook": "Book",
    "EditorIconNote": "Note",
    "EditorIconStar": "Star",
    "EditorIconTarget": "Target",
    "EditorIconFlag": "Flag",
    "EditorIconQuestion": "Question",
    "EditorIconMessage": "Message",
    "EditorIconHeadphones": "Headphones",
    "EditorIconChart": "Chart",
    "EditorIconShield": "Shield",
    "EditorIconScales": "Scales",
    "EditorPasteImageHint": "Paste an image from the clipboard or drag and drop image files here. Files are uploaded when you save the section.",
    "InteractiveBookImageEmpty": "The selected image is empty.",
    "InteractiveBookImageInvalidType": "Use a JPEG, PNG, WebP, or GIF image.",
    "InteractiveBookImageTooLarge": "Each image must be 15 MB or smaller.",
    "InteractiveBookTooManyImages": "A section can upload at most 20 new images in one save.",
    "InteractiveBookImageMappingInvalid": "One or more pending images could not be matched to the section content.",
    "InteractiveBookImageUploadError": "The image upload failed.",
    "EditorClearFormatting": "Clear formatting",
    "EditorSelectAll": "Select all",
    "EditorUndo": "Undo",
    "EditorRedo": "Redo",
    "EditorAddTextBlock": "Add text block",
    "EditorAddHeadingBlock": "Add heading block",
    "EditorAddSubheadingBlock": "Add subheading block",
    "EditorAddListBlock": "Add list block",
    "EditorAddQuoteBlock": "Add quote block",
    "EditorAddCodeBlock": "Add code block",
    "EditorAddDividerBlock": "Add divider block",
    "EditorAddImageBlock": "Add image block",
    "EditorMoveBlockUp": "Move block up",
    "EditorMoveBlockDown": "Move block down",
    "EditorBlockMoveHandle": "Drag to move block; use arrow keys to move up or down",
    "EditorDuplicateBlock": "Duplicate block",
    "EditorDeleteBlock": "Delete block",
    "EditorColor": "Color",
    "EditorTextColor": "Text color",
    "EditorFontSize": "Font size",
    "EditorFontFamily": "Font family",
    "EditorResetTextStyle": "Reset font styling",
    "ContentStructure": "Content structure",
    "ContentNavigation": "Content navigation",
    "LearningChapter": "Chapter",
    "LearningUnit": "Unit",
    "LearningSection": "Section",
    "AddChapter": "Add chapter",
    "AddUnit": "Add unit",
    "AddSection": "Add section",
    "NoContentStructure": "No chapters have been added yet.",
    "SaveInteractiveBookBeforeStructure": "Save the book first, then add chapters linked to LMS units and sections linked to their topics.",
    "SelectStructureNode": "Select a chapter or section.",
    "SaveSelectedNode": "Save selected item",
    "ConfirmDeleteLearningNode": "Delete this item and everything nested inside it?",
    "InteractiveBookStructureSaveError": "The content structure could not be saved.",
    "InteractiveBookNodeTitleRequired": "Add at least an English or Arabic title for this item.",
    "NoSectionsAvailable": "No readable sections are available yet.",
    "AboutUs": "About Us",
    "AboutUsText": "Embark on your journey to success and professional certification with Learning-Go",
    "AboutUsText1": "your trusted partner in the world of accounting, auditing, and management certifications. Our team of experts, backed by cutting-edge educational resources, is dedicated to helping you master complex concepts and pass tests with ease. At Learning-Go, we believe in focused and distraction-free learning, eliminating the need for endless searches. Your path to professional mastery starts here, with us. Begin your learning journey today.",
    "AboutUsText2": "Learning-Go ... the platform you aspire to, anytime, anywhere.",
    "ProgramsText": "We understand preparing for the professional certificate requires an enormous investment of time and efforts. Our team has the right expertise to make sure that you pass the exams from the 1st time. With Learning-Go, you are perusing your career, as you will have the tools, resources and support you need to pass the examination of the professional certificates.",
    "Programs": "Programs",
    "BrowseCertifications": "Browse the Certificates",
    "ProfessionalCertificates": "Professional Certificates",
    "OurDistinctiveness": "Our Distinctiveness",
    "SendEmail": "Send Email",
    "LearningTeam": "Learning Go Team",
    "Policies": "Policies",
    "ChooseCoursesText": "Choose from many other courses and programs that meet your expectations and needs through recorded videos in an interactive and interesting way, with additional courses and programs published periodically.",
    "ChooseCoursesText2": "Choose many online programs and courses that meet your needs and aspirations, and new programs and topics are added periodically",
    "Language": "Language",
    "Arabic": "العربية",
    "English": "English",
    "Home": "Home",
    "ChooseCertificate": "Choose a Certificate",
    "ChooseTopic": "Choose a Topic",
    "ChooseTopics": "Choose some Topics",
    "ChooseCourse": "Choose a Course",
    "Certifications": "Certifications",
    "Certification": "Certification",
    "Courses": "Courses",
    "Course": "Course",
    "OneDayCourses": "1 Day Courses",
    "OneDayCourse": "1 Day Course",
    "FeaturesWithUs": "Features of Studying with us",
    "InteractiveLearningPlatform": "Interactive Learning Platform",
    "InteractiveLearningPlatformText": "Our learning platform is flexible and user friendly, designed to make your study easier.",
    "ModernInnovativeExplanation": "Modern and Innovative Explanation",
    "ModernInnovativeExplanationText": "Our explanation of the material is interactive, modern and innovative which makes understanding the topics more interesting.",
    "PassGuarantee": "Pass Guarantee",
    "PassGuaranteeText": "Our promise to get regular updates and support to pass the international exams first time.",
    "StudyPlanner": "Study Planner",
    "StudyPlannerText": "Online tool to plan your studies flexibly based on your schedule and lifestyle.",
    "LargeTestBank": "Large Test Bank",
    "LargeTestBankText": "Our platform has large set of MCQs and Essays bank from past examination and other resources designed to prepare you to pass the international exams first time.",
    "MockExamText": "Mock exams that simulate the real exam in terms of questions, timing and layout. We have the right instructors to assess your performance and guide your study progress.",
    "EnrollNow": "Enroll Now",
    "DontHaveAccount": "Don't have an account ?",
    "AlreadyHaveAccount": "Already have an account ?",
    "Error": "Error",
    "ErrorName": "Names should contain letters only",
    "ErrorBody": "An error happend please try again later.",
    "ErrorConn": "There was a connection error, please try again later.",
    "ErrorUncaught": "Sorry, the process could not be completed, try again",
    "ErrorPassword": "Password must be more than 6 letters",
    "ErrorPasswordMax": "Password must be less than 20 letters",
    "ErrorEmailExist": "Email is already existed",
    "ErrorNameExist": "Arabic Name and English Name pair is already existed, Please Change both of them.",
    "EmailError": "Invalid Email",
    "MobileError": "Invalid Mobile",
    "FormulaErrorUnclosedParenthesis": "Formula error: Unclosed parenthesis. Expected {{count}} more closing parenthesis(es).",
    "CheckEmail": "We have sent you the code to your email. Please check your inbox or junk/spam mail.",
    "SigninFail": "Invalid Email or Password",
    "InvalidActivationCode": "This activation code is invalid or expired",
    "InvalidResetCode": "This link has expired. Please request a new link",
    "NotFound": "No Results.",
    "NoPrint": "You can't print this page",
    "Note": "Note",
    "Empty": "Empty",
    "Robot": "it's a bot",
    "ComingSoon": "Coming Soon",
    "Success": "Success",
    "Required": "Required",
    "TooLarge": "Too large file",
    "NotPic": "Invalid Image",
    "Monday": "Monday",
    "Tuesday": "Tuesday",
    "Wednesday": "Wednesday",
    "Thursday": "Thursday",
    "Friday": "Friday",
    "Saturday": "Saturday",
    "Sunday": "Sunday",
    "Days": "Days",
    "Day": "DAY",
    "Hours": "HOURS",
    "Hour": "HOUR",
    "Minutes": "MINUTES",
    "Minute": "MINUTE",
    "Min": "Min",
    "Seconds": "SECONDS",
    "Second": "SECOND",
    "Progress": "Progress",
    "TimeSpent": "Time Spent",
    "TimeSpentPerQuestion": "Time Spent Per Question",
    "From": "From",
    "To": "To",
    "OverallGrade": "Overall Grade",
    "ClickToLoadQuestion": "Open the question to load the result",
    "Users": "Users",
    "User": "User",
    "Accounts": "Accounts",
    "Categories": "Categories",
    "Category": "Category",
    "Tags": "Tags",
    "Notifications": "Notifications",
    "NormalNotification": "Normal Notification",
    "ImportantNotification": "Important Notification",
    "Validity": "Subscription validity",
    "Valid": "Valid",
    "Invalid": "Invalid",
    "Duration": "Duration",
    "Settings": "Settings",
    "ExamsSettings": "Exams Settings",
    "Dashboard": "Dashboard",
    "General": "General",
    "Gender": "Gender",
    "HR": "HR",
    "Finance": "Finance",
    "Show": "Show",
    "ViewOnly": "View Only",
    "Exams": "Exams",
    "Info": "Info",
    "Reviews": "Reviews",
    "Review": "Review",
    "ReviewAnswers": "Review Answers",
    "UsersRating": "Users Rating",
    "Stars": "Stars",
    "Map": "Map",
    "Profile": "Profile",
    "FirstName": "First Name",
    "LastName": "Last Name",
    "FullName": "Full Name",
    "ShortName": "Short Name",
    "Copon": "Copon",
    "CoponDiscount": "Copon Discount",
    "Total": "Total",
    "UsedTimes": "Used Times",
    "Buy": "Buy",
    "Reports": "Reports",
    "Report": "Report",
    "Payment": "Payment",
    "PaymentMethod": "Payment Method",
    "QTicketQatar": "Q-Ticket Qatar",
    "QTicketUAE": "Q-Ticket UAE",
    "Fatora": "Fatora",
    "InvalidPayment": "This payment is invalid or unavailable.",
    "PaymentAlreadyCompleted": "This payment has already been completed.",
    "PaymentMethodNotSupported": "This payment method is not supported.",
    "PaymentGatewayNotConfigured": "The selected payment method is not configured.",
    "PaymentGatewayRequestFailed": "Could not start the payment. Please try again.",
    "PaymentVerificationFailed": "The payment could not be verified.",
    "Payments": "Payments",
    "PaymentsReport": "Payments Report",
    "ContentReports": "Content Reports",
    "ReportProblem": "Report a Problem",
    "ThanksForReportingIssue": "Thank you for reporting a problem, we will check it",
    "PaymentValue": "Payment Value",
    "PaymentDate": "Payment Date",
    "EnsuringPaymentMessage": "The payment mechanism is secure and your data will be encrypted confidentially",
    "AssignedTo": "Assigned To",
    "Name": "Name",
    "ID": "ID",
    "Mobile": "Mobile",
    "Code": "Code",
    "Country": "Country",
    "IP": "IP",
    "IpLogs": "IP Logs",
    "SignInLogs": "Sign In Logs",
    "IpsCount": "Ips Count",
    "UseIps": "Use Ips",
    "OS": "Operating System",
    "DevicesMaxCount": "Devices Max Count",
    "DevicesCount": "Devices Count",
    "Latitude": "Latitude",
    "Longitude": "Longitude",
    "ContinentName": "Continent Name",
    "CountryName": "Country Name",
    "RegionName": "Region Name",
    "City": "City",
    "CreatedAt": "Created At",
    "Date": "Date",
    "Active": "Active",
    "Inactive": "Inactive",
    "Blocked": "Blocked",
    "Block": "Block",
    "Alive": "Alive",
    "BlockedAccountText": "The account has been locked, for violating the site and subscription policies, please contact the support team to solve the problem and for more information",
    "Correct": "Correct",
    "Visible": "Visible",
    "Trial": "Trial",
    "Email": "Email",
    "Options": "Options",
    "PleaseWait": "Please Wait",
    "CorrectOptionRequired": "Please select a correct option",
    "Option": "Option",
    "Photo": "Photo",
    "Attachments": "Attachments",
    "Attachment": "Attachment",
    "StartAt": "Start At",
    "EndAt": "End At",
    "Type": "Type",
    "ExamType": "Exam Type",
    "CorrectionDetails": "Correction Details",
    "ExamCorrection": "Exam Correction",
    "Corrected": "Corrected",
    "QuestionsType": "Question Type",
    "Theme": "Theme",
    "QuestionsCount": "Questions Count",
    "TotalDegree": "Total Degree",
    "Degree": "Degree",
    "SuccessRatio": "Success Ratio",
    "SuccessDegree": "Success Degree",
    "Distribution": "Distribution",
    "DistributionNotValid": "Distribution is not valid",
    "DistributionFillAllQuestionCount": "You still have some Mandatory questions and Random questions are less than it",
    "DistributionRule1": "You can choose at the unit or topic level",
    "DistributionRule2": "The mandatory questions equal the number of exam questions",
    "DistributionRule3": "Mandatory questions express the presence of the question in the examination for sure",
    "DistributionRule4": "Example of random questions: In the essay section of the SOCPA, there are two Mandatory questions and 12 random questions out of 6 total questions, so the four mandatory questions are chosen randomly from the 12",
    "DistributionRule5": "To express that the question is definitely prevented from appearing in the exam, we leave the box blank",
    "RandomQuestions": "Random Questions",
    "Random": "Random",
    "Mandatory": "Mandatory",
    "RemainingMandatoryQuestions": "Remaining Mandatory Questions",
    "EnterUnitRatio": "Enter Questions count for this unit",
    "EnterTopicRatio": "Enter Questions count for this topic",
    "IncrementalTime": "Incremental Time",
    "Features": "Features",
    "Feature": "Feature",
    "PasswordMustMatch": "Passwords must match",
    "Owner": "Owner",
    "Address": "Address",
    "roleId": "Role",
    "Order": "Order",
    "SocialMedia": "Social Media",
    "ArabicName": "Arabic Name",
    "EnglishName": "English Name",
    "ArabicDescription": "Arabic Description",
    "EnglishDescription": "English Description",
    "EnglishText": "English Text",
    "ArabicText": "Arabic Text",
    "EnglishAnswer": "English Answer",
    "ArabicAnswer": "Arabic Answer",
    "EnglishTitle": "English Title",
    "ArabicTitle": "Arabic Title",
    "EnglishColumnName": "English Column Name",
    "ArabicColumnName": "Arabic Column Name",
    "EnglishExplanation": "English Explanation",
    "ArabicExplanation": "Arabic Explanation",
    "EnglishStructure": "English Structure",
    "EnglishFeatures": "English Features",
    "EnglishPromise": "English Promise",
    "ArabicStructure": "Arabic Structure",
    "ArabicFeatures": "Arabic Features",
    "ArabicPromise": "Arabic Promise",
    "BioEn": "English Biography",
    "BioAr": "Arabic Biography",
    "SpecialtyEn": "English Specialty",
    "SpecialtyAr": "Arabic Specialty",
    "KeyWords": "Keywords",
    "Columns": "Columns",
    "Column": "Column",
    "Answers": "Answers",
    "Answer": "Answer",
    "Rank": "Rank",
    "Price": "Price",
    "Cost": "Cost",
    "Discount": "Discount",
    "John": "John",
    "Doe": "Doe",
    "New": "New",
    "Accepted": "Accepted",
    "Accept": "Accept",
    "Rejected": "Rejected",
    "Reject": "Reject",
    "Pending": "Pending",
    "Cancel": "CANCEL",
    "Exit": "Exit",
    "OK": "OK",
    "Add": "ADD",
    "Save": "SAVE",
    "Reset": "RESET",
    "Delete": "DELETE",
    "ADD": "Add",
    "EDIT": "Edit",
    "Edit": "Edit",
    "READ": "Read",
    "Read": "Read",
    "Export": "Export",
    "EXPORT": "Export",
    "Send": "SEND",
    "Next": "Next",
    "Previous": "Previous",
    "Start": "Start",
    "Done": "Done",
    "Generate": "Generate",
    "Join": "JOIN",
    "Create": "Create",
    "Confirm": "Confirm",
    "RemoveAll": "Remove all",
    "Views": "Views",
    "Likes": "Likes",
    "Dislikes": "Dislikes",
    "Viewers": "Viewers",
    "LookingFor": "LOOKING FOR ?",
    "Back": "Back",
    "BackToHome": "Back to home",
    "Search": "SEARCH",
    "Choose": "Choose",
    "Logout": "Logout",
    "SelectAll": "SELECT ALL",
    "DeselectAll": "DESELECT ALL",
    "Max": "Max",
    "Activate": "Activate",
    "WriteWisly": "Write Wisely",
    "Security": "Security",
    "Comments": "Comments",
    "Comment": "Comment",
    "ViewMoreComments": "View more comments...",
    "Rate": "Rate",
    "CommentHere": "Comment Here...",
    "GeneralComment": "General Comment",
    "CorrectorComment": "Corrector Comment",
    "StudentAnswer": "Student Answer",
    "TimeAndDate": "Time & Date",
    "SortBy": "SORT BY",
    "Location": "Location",
    "Status": "Status",
    "Title": "Title",
    "Anonymous": "Anonymous",
    "InActiveAccount": "This account is disabled, please contact the administration to reactivate it",
    "Saved": "SAVED",
    "Added": "ADDED NEW",
    "Deleted": "DELETED",
    "Actions": "Actions",
    "Action": "Action",
    "Performance": "Performance",
    "Sec": "Sec",
    "Essay": "Essay",
    "MCQS": "MCQS",
    "Text": "Text",
    "Tbs": "TBS",
    "File": "File",
    "Files": "Files",
    "FileBank": "Files Bank",
    "TbsBank": "Tbs Bank",
    "McqsBank": "Mcqs Bank",
    "EssaysBank": "Essays Bank",
    "MockExam": "Mock Exam",
    "TestKnowledge": "Test Knowledge",
    "Subscriptions": "Subscriptions",
    "Subscription": "Subscription",
    "Subscribers": "Subscribers",
    "Subscriber": "Subscriber",
    "SubscriptionPackage": "Subscription Package",
    "SubscriptionType": "Subscription Type",
    "SubscriptionCost": "Subscription Cost",
    "Paid": "Paid",
    "Visitor": "Visitor",
    "Visitors": "Visitors",
    "Students": "Students",
    "Student": "Student",
    "Promotions": "Promotions",
    "Promotion": "Promotion",
    "Permissions": "Permissions",
    "Permission": "Permission",
    "NotAllowed": "You're not allowed to access this page",
    "Admins": "Admins",
    "Admin": "Admin",
    "Units": "Units",
    "Unit": "Unit",
    "Topic": "Topic",
    "Topics": "Topics",
    "Questions": "Questions",
    "Question": "Question",
    "Size": "Size",
    "Sizes": "Sizes",
    "Difficulty": "Difficulty",
    "Difficulties": "Difficulties",
    "Book": "Document",
    "Books": "Books",
    "Video": "Video",
    "Videos": "Videos",
    "Images": "Images",
    "Image": "Image",
    "Lives": "Lives",
    "TopTenVideos": "Top 10 Videos",
    "Uploads": "Uploads",
    "Loading": "Loading",
    "Subject": "Subject",
    "Preview": "Preview",
    "Message": "Message",
    "Messages": "Messages",
    "Package": "Package",
    "Packages": "Packages",
    "CertificationsPackages": "Certifications Packages",
    "CoursesPackages": "Courses Packages",
    "UnitsPackages": "Units Packages",
    "CoursesSubscriptions": "Courses Subscriptions",
    "UnitsSubscriptions": "Units Subscriptions",
    "Onetime": "One Time",
    "Period": "Period",
    "Description": "Description",
    "Instructor": "Instructor",
    "Instructors": "Instructors",
    "FullReviewSystem": "full review system",
    "TestBankMockExams": "test bank and mock exams",
    "MockExams": "Mock Exams",
    "MockAndBankExams": "Mock & Bank",
    "BankExams": "Bank Exams",
    "FrequentlyExams": "Frequently Exams",
    "BankAndFreqExams": " Bank & Frequently",
    "FreqAndMockExams": "Frequently & Mock",
    "BankAndFreqAndMockExams": "Bank & Frequently & Mock",
    "UsedFor": "Used For",
    "StudentDiscountsAvailable": "Student Discounts Available",
    "HighQualityTestBank": "High Quality Test Bank and Essay Questions, Including video explanation",
    "RealisticExam": "Realistic Exam Day Experience",
    "FullSupportAssistance": "Full Support and Assistance",
    "DigitalMaterialSlides": "Digital Material and Slides",
    "VideoLecturesSeries": "Video Lectures Series",
    "OnlineStudyPlanner": "Online Study Planner",
    "PersonalMentoring": "Personal Mentoring by Mohammad CMA",
    "SuccessStories": "Success Stories",
    "NewsInfo": "New Info",
    "CertificateInfo": "Certificate Info",
    "UserInfo": "User Info",
    "AdminInfo": "Admin Info",
    "CourseInfo": "Course Info",
    "UnitInfo": "Unit Info",
    "TopicInfo": "Topic Info",
    "OneDayCourseInfo": "One Day Course Info",
    "SizeInfo": "Size Info",
    "DifficultyInfo": "Difficulty Info",
    "CategoryInfo": "Category Info",
    "PromotionInfo": "Promotion Info",
    "ProblemInfo": "Problem Info",
    "QuestionInfo": "Question Info",
    "OptionInfo": "Option Info",
    "RoleInfo": "Role Info",
    "PackageInfo": "Package Info",
    "SubscriptionInfo": "Subscription Info",
    "InstructorInfo": "Instructor Info",
    "SuccessStoryInfo": "Success Story Info",
    "CalendarInfo": "Calendar Info",
    "Calendar": "Calendar",
    "CoursesCalendar": "Courses Calendar",
    "AddNewResource": "Add New Resource",
    "Role": "Role",
    "Roles": "Roles",
    "Resource": "Resource",
    "Resources": "Resources",
    "Explanations": "Explanations",
    "Explanation": "Explanation",
    "Format": "Format",
    "Solved": "Solved",
    "Remaining": "Remaining",
    "Flagged": "Flagged",
    "Flag": "Flag",
    "Finish": "Finish",
    "FinishSection": "Finish Section",
    "QuestionsNumber": "Number of questions",
    "ChangeNumberQuestions": "Change number of questions",
    "ChooseOrderQuestions": "Choose an order for the questions",
    "StartExam": "Start your exam",
    "Decline": "Decline",
    "ChangeNumberQuestionsText": "Enter the number of questions you want to review",
    "ChooseOrderQuestionsText": "In what order should the system present the questions",
    "InStandardOrder": "Standard Order",
    "InRandomOrder": "Random Order",
    "SelectCourse": "Select a course",
    "SelectUnit": "Select Unit",
    "NoExplanation": "Incorrect Answer",
    "YourAnswer": "Your Answer",
    "YouDidNotAnswer": "You did not answer",
    "ShowProblem": "Show the problem",
    "PleaseSelectCourseToStudy": "Please select a course first from your dashboard",
    "NoQuestions": "This exam is not included in this course yet",
    "YES": "YES",
    "NO": "NO",
    "ExamNotAllowed": "Sorry, You are not subscribed to a package that allows you to take this exam",
    "NoExam": "This exam is not included in this course yet",
    "Watch": "Watch",
    "Open": "Open",
    "News": "News",
    "Announcements": "Announcements",
    "IntroductoryVideo": "An introductory video about the platform",
    "IntroductoryVideoText": "Watch the following introductory video on how the platform works and how to navigate the options and pages",
    "Other": "Other",
    "OtherCourses": "Other Courses",
    "OurAchievements": "What We Have Achieved So Far",
    "AlreadySubscribed": "You're already subscribed to this package",
    "AlreadySubscribedButNotPaid": "You are already subscribed to this package, but you did not pay the subscription, go to the subscriptions page and press the payment button",
    "YourExamWillStart": "Your study questions are about to start, are your ready?",
    "YourExamHasFinished": "Your exam has finished, Thank You",
    "YourViewHasFinished": "Your view has finished, Thank You",
    "ExamResults": "Exam Results",
    "Result": "Result",
    "ResultAnalysis": "Result Analysis",
    "PassingScore": "Passing Score is",
    "Passed": "Passed",
    "Failed": "Failed",
    "BadUnitResult": "You need a noticeable improvement in this part",
    "MidUnitResult": "You need some improvement in this part",
    "GoodUnitResult": "You are excellent at this part",
    "CorrectAnswers": "Correct Answers",
    "CorrectAnswer": "Correct Answer",
    "WrongAnswers": "Wrong Answers",
    "WrongAnswer": "Wrong Answer",
    "NotAnswered": "Not Answered",
    "NotAnsweredQuestion": "Not Answered",
    "Answered": "Answered",
    "FlaggedQuestions": "Flagged Questions",
    "RetryWrong": "Re-exam wrong questions",
    "RetryFlagged": "Re-exam flagged questions",
    "RetryNotAnswered": "Re-exam not answered questions",
    "MoveToEssaySection": "Move to Essay Section",
    "MoveToEssaySectionText1": "You have finished the Multiple Choice Questions section.",
    "MoveToEssaySectionText2": "Would you like to continue and move to the Essay section or come back later to complete the test?",
    "MoveToNextSectionText1": "You have finished this section.",
    "MoveToNextSectionText2": "Would you like to continue and move to the next section or come back later to complete the test?",
    "MoveToNextSectionText3": "Please click Continue to move to the next section. If you leave the exam, you cannot return to it later.",
    "StopBackLater": "Stop and come back later",
    "ContinueMoveEssay": "Continue - move to the essay question section",
    "ContinueMove": "Continue - move to the next question section",
    "SubmitTestLet": "Submit Testlet",
    "TestLet": "TESTLET {{letNumber}}",
    "AUDITINGANDATTESTATION": "AUDITING AND ATTESTATION",
    "AreYouReadyForExam": "Are you ready to start your exam?",
    "AreYouSureFinishExam": "Are you sure you want to finish the exam?",
    "AreYouSureFinishSectionExam": "Are you sure you want to go to the Essay Section ? Once you go to the Essay Section, you cannot go back to this section",
    "AreYouSure?": "Are You Sure?",
    "MockExamFinishText1": "Please note that we will send you an email with your performance report soon after marking your answer",
    "MockExamFinishText2": "Please check your email and get back to us if you have any questions",
    "MockNot50Text": "You did not correctly answer half of the questions in the first section",
    "MockNotAnswerRequiredToMoveText": "You did not answer enough questions in this section to move on to the next section.",
    "MockPageWarning": "If you don't achieve a total performance progress of 85%, you will not qualify for Learning-Go passing guarantee.",
    "MockPageListText1": "This section contains two mock exams.",
    "MockPageListText2": "We recommend you complete the Mock Exam 1 approximately “two” weeks before the real exam.",
    "MockPageListText3": "We recommend you complete the Mock Exam 2 approximately “one” week before the real exam.",
    "MockPageListText4": "Mock Exams are a comprehensive exam and include new questions that are designed to help you identify areas of weaknesses.",
    "MockPageListText5": "After completing the mock exams, review the summary report and then reinforce weak areas by reviewing the lectures and practice more MCQs and Essays.",
    "MockExam1": "Mock Exam 1",
    "MockExam2": "Mock Exam 2",
    "Recommendations": "Recommendations",
    "Warning": "Warning",
    "AlreadyOnGoingExam": "You have a previous exam, do you want to continue or not?",
    "PolicyAgreement": "Policy Statement and Confidentiality Agreement",
    "PolicyAgreementText": "I hereby attest that I will not divulge the content of this examination, nor will I remove any examination materials, notes or other unauthorized materials from the examination room. I understand that failure to comply with this attestation may result in invalidation of my grades and disqualification from future examinations. For those already certified, failure to comply with the statement will be considered a violation of the Ethical Professional Practice and could result in revocation of the certification.",
    "PolicyAgreementCIA": "Non-Disclosure Agreement for Confidential Information and Terms of Use for Certified Internal Audit Test",
    "PolicyAgreementTextCIA": "I agree to comply with and adhere to the rules of the Learning-Go platform, including the Non-Disclosure Agreement and the General Terms of Use. I acknowledge that this exam is confidential and protected by copyright law. <br/> I will not view the questions or answers that may appear directly in the exam, and I agree not to discuss the exam content with anyone else.<br/> I will not record, copy, disclose, publish, or re-release any questions from the exam or their answers, either partially, fully, or in any manner or by any means before, during, or after taking the exam, whether orally, in writing, via any online chat room, bulletin board, forum, text message, or by any other means.<br/> You will not be allowed to continue if you refuse to accept these terms.",
    "PolicyAgreementTextCIAHeader": "Acceptance of the confidentiality agreement",
    "PolicyAgreementCIAAccept": "Yes, I accept the Non-Disclosure Agreement and the Terms of Use for the Certified Internal Audit Test",
    "PolicyAgreementCIADecline": "No, I do not accept the Non-Disclosure Agreement and the Certified Internal Audit Test Terms of Use",
    "A": "A",
    "B": "B",
    "C": "C",
    "D": "D",
    "TermsAndConditions": "Terms & Conditions",
    "PrivacyPolicy": "Privacy Policy",
    "ImportantLinks": "Important Links",
    "Link": "Link",
    "FollowUs": "Follow Us",
    "AllRightsReserved": "Learning-Go, All Rights Reserved",
    "NA": "N.A",
    "PrivacyPolicyIntroText": "Our privacy policy along with both our publishing and terms of use, builds the foundation which will determine your relationship with us and vice versa. We recognize the importance of securing certain basic information when you visit our website. Please read the following carefully to ensure a comprehensive understanding of our views and practices regarding your personal and any information you provide us with and how we will treat that information.",
    "PrivacyPolicyInfoCollecting": "Information we collect and process from you",
    "PrivacyPolicyInfoCollectingText1": "The following data may be required from you to provide you with authorization that will enable you to access certain features within our website:",
    "PrivacyPolicyInfoCollectingList1Text1": "Information you provide us with when filling our fields of all forms within our site. This including the information you give when you register to use our website, when you subscribe to our services, and sometimes when you report a problem using our website.",
    "PrivacyPolicyInfoCollectingList1Text2": "We may also keep records of any email, telephone or post you use to contact us.",
    "PrivacyPolicyInfoCollectingList1Text3": "We include surveys within our website that may request certain information from you, though taking part in our surveys is completely optional.",
    "PrivacyPolicyInfoCollectingText2": "The following details we collect from your visits to our site:",
    "PrivacyPolicyInfoCollectingList2Text1": "traffic data",
    "PrivacyPolicyInfoCollectingList2Text2": "location data",
    "PrivacyPolicyInfoCollectingList2Text3": "weblogs",
    "PrivacyPolicyInfoCollectingList2Text4": "operating system",
    "PrivacyPolicyInfoCollectingList2Text5": "browser usage",
    "PrivacyPolicyInfoCollectingList2Text6": "other communication data – whether necessary for you own billing purposes or otherwise and the resources that you access.",
    "PrivacyPolicyIpAddress": "IP Address and Cookies",
    "PrivacyPolicyIpAddressText1": "We may collect the following information about your computer:",
    "PrivacyPolicyIpAddressList1Text1": "IP address",
    "PrivacyPolicyIpAddressList1Text2": "operating system",
    "PrivacyPolicyIpAddressList1Text3": "browser type",
    "PrivacyPolicyIpAddressText2": "For system administration and to report accumulated data to our advertisers.",
    "PrivacyPolicyIpAddressText3": "This information will be collected solely for statistical purposes and will not in any way attempt to identify an individual person.",
    "PrivacyPolicyIpAddressText4": "Information may be obtained via a cookie file which will be stored within your computer hard drive. This file will transmit certain information to your hard drive ensuring our delivery of a more personalized service and to :",
    "PrivacyPolicyIpAddressList2Text1": "enable us to predict the size of our audience and their usage pattern;",
    "PrivacyPolicyIpAddressList2Text2": "to collect information regarding your preferences, hence allowing us to customize our site in accordance with your interests and preferences;",
    "PrivacyPolicyIpAddressList2Text3": "to accelerate your searches",
    "PrivacyPolicyIpAddressList2Text4": "and so our system can recognize you when you return to our website.",
    "PrivacyPolicyIpAddressText5": "If you do not wish to accept cookies, you may activate the browser setting responsible for cookies. Unless you active that browse, our system will release the cookies onto your hard drive when you log onto our site.",
    "PrivacyPolicyStorePersonalData": "Where we store your personal data",
    "PrivacyPolicyStorePersonalDataText1": "All provided information will be stored on our secure systems. It is your own responsibility to keep any password we give you (or you choose) to enable access to certain features within our website confidential. We recommend you don’t share a password with anyone to ensure security to your account and data.",
    "PrivacyPolicyStorePersonalDataText2": "We have strict procedures and security systems to best keep your data safe and prevent unauthorized access. However, the internet is not entirely secure. So any information you provide us with via internet will be at your own risk.",
    "PrivacyPolicyWithInfo": "What we do with your information",
    "PrivacyPolicyWithInfoText1": "The information we keep about you will be used to :",
    "PrivacyPolicyWithInfoList1Text1": "ensure our material is offered to you in the best possible form for you and your computer;",
    "PrivacyPolicyWithInfoList1Text2": "to provide you with all the information and services relevant to your interests or your requests where you have approved we contact you for such purposes.",
    "PrivacyPolicyWithInfoList1Text3": "To carry out our duties regarding any contracts between you and us.",
    "PrivacyPolicyWithInfoList1Text4": "So you can utilize our interactive features when you like.",
    "PrivacyPolicyWithInfoList1Text5": "To provide you with notifications in case of any changes.",
    "PrivacyPolicyDisclosure": "Disclosure of your information",
    "PrivacyPolicyDisclosureText1": "Your information may be disclosed to third parties for the following reasons:",
    "PrivacyPolicyDisclosureList1Text1": "If we are obliged to share such data as to comply with certain legal requirements, customers or others.",
    "PrivacyPolicyDisclosureList1Text2": "to prevent fraud and credit risk",
    "PrivacyPolicyDisclosureList1Text3": "if we are selling or buying any of your business properties, we may need to disclose your information to the buyer or seller of such properties.",
    "PrivacyPolicyYourRights": "Your rights",
    "PrivacyPolicyYourRightsText1": "Our website may contain links to other websites or partner corporations. Please read their policies and terms carefully before posting and personal information as we are not responsible for these sites or their regulations.",
    "PrivacyPolicyYourRightsText2": "If we intent to disclose your personal information to any third party, we will usually inform you before we collect any information. You will be able to prevent such processing by ticking certain boxes in our forms or pages. You may also contact us via info@learning-go.com if you have any inquiries.",
    "PrivacyPolicyAccessInfo": "Access to information",
    "PrivacyPolicyAccessInfoText1": "You have the right to access your information and any information we hold about you.",
    "PrivacyPolicyChanges": "Changes to our privacy policy",
    "PrivacyPolicyChangesText1": "We recommend you check our policies from time to time to stay updated on any changes. We may notify you regarding any significant changes we make to this page.",
    "PrivacyPolicyContact": "Contact",
    "PrivacyPolicyContactText1": "Questions, comments and requests regarding this privacy policy are welcomed and should be addressed to info@learning-go.com",
    "TermsOfUseText": "By continuing to use and navigate our site, you are agreeing to comply with all our regulations which together form our publishing policy, privacy policy, and the following terms of use. If you disagree with any of the terms mentioned, we recommend you don’t continue using our website. The term “Learning-Go” or “us” or “we” refers to the owner of this website. The terms “you” refers to the users and readers of this website. If you have any concerns, please feel free to inquire using the following address: info@learning-go.com",
    "TermsOfUseReliance": "Reliance on Information Posted & Disclaimer",
    "TermsOfUseRelianceText1": "Any content or material within our website is provided for general purposes only. We do not hold any responsibility for any loss which may come from accessing the information on this site and to the fullest extent permitted by the applicable law, we are not accountable for any direct or indirect loss or damages that may arise from using our website.",
    "TermsOfUseAccessing": "Accessing our site",
    "TermsOfUseAccessingText1": "Access to our website is permitted on a temporary basis, and we reserve the right to withdraw or modify the service we provide on our site without notice. We are not responsible if for any reason, our site is unavailable at any time or for any period.",
    "TermsOfUseIntellectual": "Intellectual property rights",
    "TermsOfUseIntellectualText1": "Learning-Go holds ownership to all material, content and published material within our website. All works are reserved and protected by copyright laws and treaties around the world.",
    "TermsOfUseIntellectualText2": "Users may print off one copy, download extracts of our content on any of our pages for their own personal reference. You may also draw the attention of others in your corporation to material within our website.",
    "TermsOfUseIntellectualText3": "Any material you download, or print from our website must not be modified, you must not use any photographs, illustrations, images, graphics, videos or audios on this site separate from their accompanying text.",
    "TermsOfUseIntellectualText4": "As authors of the material within our website, we, along with any identified contributors must always be acknowledged. You cannot use any material within our website for commercial purposes or without our permission to do so from us or our licencors.",
    "TermsOfUseIntellectualText5": "Any breach of the former regulations will prohibit you from further using our website and you must erase, return or destroy any of the copied or used material.",
    "TermsOfUseFrequentlyUpdate": "Our website is frequently updated",
    "TermsOfUseFrequentlyUpdateText1": "Our goal is to update and apply changes to our website whenever and wherever we see fit. This means some content may be altered at any time during which we may suspend access to our site, or choose to close it indefinitely. Any data or material within our website may be out of date and we are not obliged to update such material.",
    "TermsOfUseResponsibility": "Our responsibility",
    "TermsOfUseResponsibilityText1": "Any material uploaded or displayed within our website holds no guarantees, warranties or conditions as to its accuracy.",
    "TermsOfUseResponsibilityText2": "We, along with any of our associated third parties exclude the following:",
    "TermsOfUseResponsibilityText3": "All conditions, warranties and other terms which might otherwise be implied by statute, common law or the law of equity.",
    "TermsOfUseResponsibilityText4": "Any responsibility for direct, indirect or significant loss or damage sustained by any user in relation to our site or in connection with the use, inability to use, or outcomes of the use of our website, any websites linked to it and any content uploaded or posted on it, including, without limitation any accountability for:",
    "TermsOfUseResponsibilityList1Text1": "loss of income or revenue.",
    "TermsOfUseResponsibilityList1Text2": "loss of business.",
    "TermsOfUseResponsibilityList1Text3": "loss of profits or contracts.",
    "TermsOfUseResponsibilityList1Text4": "loss of estimated savings.",
    "TermsOfUseResponsibilityList1Text5": "loss of data.",
    "TermsOfUseResponsibilityList1Text6": "loss of goodwill.",
    "TermsOfUseResponsibilityList1Text7": "wasted management or office time.",
    "TermsOfUseResponsibilityText5": "For any loss or damage that may occur whether caused by accident, breach of contract or otherwise, even if predicted, on the condition that this condition shall not thwart claims for loss of or damage to your tangible property or any other claims for direct financial loss that are not excluded by any of the aforementioned categories.",
    "TermsOfUseResponsibilityText6": "This does not affect our liability for personal injury arising from our negligence, nor our liability for fraudulent misrepresentation or misrepresentation as to a fundamental matter, nor any other liability which cannot be excluded or limited under applicable law.",
    "TermsOfUseYourInformation": "Information about you and your visits to our site",
    "TermsOfUseYourInformationText1": "We process information about you in compliance with our Privacy Policy. And by using our site, you agree to such processing and you warrant that all or any data provided and uploaded by you is accurate, unless you have permission from us to do otherwise.",
    "TermsOfUseViruses": "Viruses, hacking and other offenses",
    "TermsOfUseVirusesText1": "Knowingly misusing our website by introducing malicious or technologically harmful material such as viruses, Trojans, worms, logic bombs or similar material will immediately cease your right to use our website.",
    "TermsOfUseVirusesText2": "Attempting to gain unauthorized access to our website or and through any computer, device or database in which our site is stored on or connected to our website, will also result in exclusion from using our site.",
    "TermsOfUseVirusesText3": "Attacking our website via a denial-of-service attack or a distributed denial-of service attack will have similar outcomes to the aforementioned breaches.",
    "TermsOfUseVirusesText4": "Learning-Go will not be held accountable for any loss or damage that may arise from a distribution denial-of-service attack, malicious or technologically harmful material that may infect your computer devices, programs, data or other materials due to your use of our sites or as a result of downloading any of the material available within our site.",
    "TermsOfUseLinks": "Links from our site",
    "TermsOfUseLinksText1": "Our site may contain links to other websites. These links are provided for your information and reference only.  We do not own and or hold any responsibility whatsoever to any of these linked sites. Their content is their own, and we have no control over the material provided within. Learning-Go is not accountable for any loss or damage which may arise from your use of these sites. When visiting any of these websites through our pages, we advise you to read their policies and terms of use to ensure your compliance and to determine how these sites will use your information.",
    "TermsOfUseJurisdiction": "Jurisdiction and applicable law",
    "TermsOfUseJurisdictionText1": "These terms of use and any dispute or claim arising out of or in connection with them or their subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the applicable law.",
    "TermsOfUseVariations": "Variations",
    "TermsOfUseVariationsText1": "We may update these terms at any time, so please check this page from to time to ensure you are familiar with all our terms and conditions. This to prevent any misunderstanding or breech of new regulations. Some of the terms within this policy may be superseded by other provisions mentioned elsewhere on this site.",
    "TermsOfUseYourConcerns": "Your Concerns",
    "TermsOfUseYourConcernsText1": "If you have any concerns about material which appears on our site, please contact info@learning-go.com",
    "ThanksText": "Thank you for visiting our site!",
    "OurCertificates": "Our Certificates",
    "ExploreSuccessStory": "Explore Our Success Story",
    "Submit": "Submit",
    "Male": "Male",
    "Female": "Female",
    "EditProfile": "Edit Profile",
    "AvailableCourses": "Available Courses",
    "Support": "Support & Complaints",
    "UnitComplition": "Unit Complition",
    "UseCopon": "Use Copon",
    "NotificationsAppearHere": "All your notifications will appear here",
    "SelectExamQuestions": "Select Exam Questions",
    "NumberOfQuestionsAndSorting": "Number of Questions & Sorting",
    "ExitExam": "Finish Exam",
    "BackToExam": "Back to Exam",
    "Continue": "Continue",
    "ManualPayments": "Manual Payments",
    "PaymentTime": "Payment Time",
    "PaymentInfo": "Payment Info",
    "PayeeName": "Payee Name",
    "ERR_SUBSCRIBE_PAYED": "The subscription is fully paid",
    "HonorRoll": "Honor Roll",
    "UserPerformance": "User Performance",
    "CopyCourse": "Copy Course",
    "Clone": "Clone",
    "Up": "Up",
    "Down": "Down",
    "ChangeImage": "Change Image",
    "DeleteImage": "Delete Image",
    "ExamName": "Exam Name",
    "AddNote": "Add Note",
    "InvalidArgument": "Invalie Arguments",
    "InvalidUserAccountActivationCode": "Invalid Activation Code",
    "InvalidUserAccountResetPasswordCode": "Invalid Reset Code",
    "NotExistsUserEmail": "Email not Found",
    "DuplicateEmail": "Existed Email",
    "InvalidEmail": "Invalid Email",
    "InvalidPassword": "Invalid Password",
    "InvalidFirstname": "Invalid First Name",
    "InvalidLastname": "Invalid Last Name",
    "InvalidName": "Invalid Name",
    "UnknownError": "Unknown Error",
    "InactiveAccount": "Inactive Account",
    "BlockedAccount": "Blocked Account",
    "InvalidSubscriptionPackage": "Invalid Subscription Package",
    "Mock1LinkNotFound": "Mock 1 not Found",
    "Mock1NotFinished": "Mock 1 not Finished",
    "LastExamRoundNotFinished": "Last Exam Round is not Finished",
    "ExamAttemptsCountExceeded": "Mock Exam Attemps Exceeded",
    "UserHasValidSubscriptionOnPackage": "You already have got a valid Subscription",
    "UserHasNotCompleteSubscriptionOnPackage": "You already have got unpayed Subscription",
    "DuplicateCode": "Duplicate Code",
    "NOT_ALLOWED_EXAM_TYPE": "Exam not Allowed",
    "CanNotDeleteUsedEntity": "Can't Delete Used Entity",
    "Composite": "Composite",
    "FileQuestions": "File Questions",
    "Section": "Section",
    "DeleteAll": "Delete All",
    "TextSection": "Text Section",
    "SelectorSection": "Selector Section",
    "ParagraphSection": "Paragraph Section",
    "TableSection": "Table Section",
    "CheckBoxesSection": "CheckBoxes Section",
    "ChoicesManagement": "Choices Management",
    "CellsManagement": "Cells Management",
    "TasksManagement": "Tasks Management",
    "Content": "Content",
    "AddNewSection": "Add New Section",
    "GenerateTasks": "Generate Tasks",
    "GenerateCells": "Generate Cells",
    "FieldsCount": "Fields Count",
    "RowsCount": "Rows Count",
    "ColumnsCount": "Columns Count",
    "MultiChoiceQuestionOptions": "Multi Choices Question Options",
    "InsertAnswerForTask": "Insert Answers for task {{task}}",
    "SelectorSectionHowToWork": "If you want to put a sentence containing a question, put this sentence within the symbol @@{the sentence here} After you have finished writing the entire text, click on Generate Tasks to begin the process of entering options",
    "ERR_CANNOT_ADD_NEWS_POPUP_WITH_CONFILCTING_DATES": "You can't add more than one popup news with conflicting date",
    "DiscountType": "Discount Type",
    "Amount": "Amount",
    "Percent": "Percent",
    "EnglishButtonText": "English Button Text",
    "ArabicButtonText": "Arabic Button Text",
    "RegStrategy": "Reg Method",
    "Translate": "Translate",
    "VideoInfoEdit": "Edit Video Info",
    "REPLACE": "REPLACE",
    "KEEP": "KEEP",
    "DELETE": "DELETE",
    "SerialNumber": "Serial Number",
    "SelectOptionBelow": "Select an option below",
    "FormattedResponse": "Formatted Response",
    "PresentValueTable": "Present Value Table",
    "ColSpan": "Column Span",
    "RowSpan": "Row Span",
    "Introduction": "Introduction",
    "DifrIntroText1": "This sample test demonstrates how the live test is structured and evaluated, the likely layout and style of the questions, and the range of answer options available to you in each question workspace.",
    "DifrIntroText2": "This sample test is recommended to familiarize yourself with the workspace and the features and functionality included in the live test. ",
    "DifrIntroText3": "This sample test resembles the live test experience, but includes a few differences:",
    "DifrIntroText4": "In the live test, your answers entered in the workspace answer options will be marked by an expert. In this test, you must use the relevant solution materials.",
    "DifrIntroText5": "If you wish to take this test under conditions similar to traditional tests, you must answer the questions provided within the time limit specified in the test without referring to the solution files previously.",
    "Navigator": "Navigator",
    "Requirements": "Requirements",
    "Exhibits": "Exhibits",
    "ResponseOptions": "Response Options",
    "WordProcessor": "Word Processor",
    "Spreadsheet": "Spreadsheet",
    "ScratchPad": "Scratch Pad",
    "CloseAll": "Close All",
    "Close": "Close",
    "Marks": "Marks",
    "DuplicateRank": "Duplicated Rank",
    "Part": "Part",
    "EditToSeeContent": "Edit to see content",
    "Chapters": "Chapters",
    "MockExamsManagement": "Mock Exams Management",
    "ExamsManagement": "Exams Management",
    "ParentExam": "Parent Exam",
    "ExamOrderBetweenTopics": "Exam Order after Topic",
    "Demonstration": "Demonstration",
    "ExamInfo": "Exam Info",
    "Inferential": "Inferential",
    "Analytical": "Analytical",
    "Comprehensible": "Comprehensible",
    "FreqExam": "Frequent Exam",
    "FreqParentExam": "Frequent Parent Exam",
    "INVALID_EXAM_PARENT": "Invalid Exam Parent",
    "INVALID_EXAM_ORDER_NUM": "Invalid Exam Order Number",
    "TopicsAnalysis": "Topic Analysis",
    "AllQuestionHaveBeenCorrected": "All questions have been corrected",
    "StartCorrection": "Start exam correction and analyze results",
    "Main": "Main",
    "YouHaveToAddMoreQuestions": "You have to add more questions",
    "EXCEED_ALLOWED_COUNT": "You are not allowed to exceed the total count",
    "StudentCanCorrect": "Student Correction",
    "OnlyAdminCanCorrectThisQuestion": "Only admins can correct this question",
    "ExamLinks": "Exam Links",
    "ExpireAt": "Expire At",
    "Public": "Public",
    "Frequently": "Frequently",
    "ResponseFiles": "Response Files",
    "INVALID_PASS_LINK": "The link is invalid or expired",
    "INVALID_USER": "Invalid User",
    "Clear": "Clear",
    "AttemptsCount": "Attempts Count",
    "TryAgain": "Try Again",
    "GoHome": "Go Home",
    "Blogs": "Blogs",
    "Blog": "Blog",
    "Event": "Event",
    "Events": "Events",
    "BlogInfo": "Blog Info",
    "Blogging": "Blogging",
    "AddNewBlock": "Add New Block",
    "TextBlock": "Text Block",
    "VideoBlock": "Video Block",
    "GalleryBlock": "Gallery Block",
    "FileBlock": "File Block",
    "DeleteBlock": "Delete Block",
    "EnglishVideo": "English Video",
    "ArabicVideo": "Arabic Video",
    "EnglishGallery": "English Gallery",
    "ArabicGallery": "Arabic Gallery",
    "BlogView": "Blog View",
    "PasteLink": "Paste Link Here",
    "Pinned": "Pinned",
    "ContentSettings": "Content Settings",
    "ShowMainImage": "Show Main Image",
    "ReadMore": "Read More",
    "FAQs": "FAQS",
    "RelatedBlogs": "Related Blogs",
    "Fav": "Favorite",
    "FavoriteQuestions": "Favorite Questions",
    "PreferredTypes": "Choose Preferred Types",
    "NotAnsweredQuestionBefore": "Not Answered Before",
    "AnsweredQuestionBefore": "Answered Before",
    "NeedHintText": "If you need a hint you can delete some options",
    "DeleteSomeAnswers": "Delete Some Options",
    "CmaAgreeToTerm": "Agree to Term",
    "CmaAgreeToTermText1": "CONFIDENTIALITY AGREEMENT",
    "CmaAgreeToTermText2": "I hereby attest that I will not divulge the content of this examination, nor will I remove any examination materials, notes or other unauthorized materials from the examination room. I understand that failure to comply with this attestation may result in invalidation of my grades and disqualification from future examinations. For those already certified by the Institute of Certified Management Accountants, failure to comply with the statement will be considered a violation of IMA’s Statement of Ethical Professional Practice and could result in revocation of the certification.",
    "CmaAgreeToTermText3": "By clicking 'I accept these terms' you affirm that you accept the terms of this agreement. If you do not accept the terms of this agreement, you must click the 'Exit' button and your exam will terminate.",
    "CmaIacceptTerms": "I accept these terms",
    "PageRequiresScrolling": "This page requires scrolling",
    "CmaConfirmFinish": "Confirm Finish",
    "CmaFinishExam": "If you select Finish, your answers will be submitted and you will not be able to return to the exam.",
    "CmaFinishExamNotAllQuestionsNoFlags": "You have not attempted all of the questions in this test",
    "CmaFinishExamNotAllQuestionswithFlags": "You have not attempted all of the questions in this test, and some have been flagged.",
    "CmaAreYouSureFinishExam": "Are you sure you would like to finish the test",
    "FilterBy": "Filter By",
    "Unattempted": "Unattempted",
    "NotAttempted": "Not Attempted",
    "UnSeen": "Unseen",
    "Attempted": "Attempted",
    "E": "E",
    "Calculator": "Calculator",
    "CopyExam": "Copy Exam",
    "QuestionsDistribution": "Questions Distribution",
    "RatioDistribution": "Ratio Distribution",
    "EXAM_PARENT_INACTIVE": "You can't change it, The Parent Exam is'nt active",
    "Steps": "Steps",
    "UploadVideos": "Upload Videos",
    "UploadBooks": "Upload Books",
    "VideoInfo": "Video Info",
    "BookInfo": "Book Info",
    "PowerPoint": "Power Point",
    "Word": "Word",
    "Excel": "Excel",
    "PDF": "PDF",
    "ZipFile": "ZIP archive",
    "CourseResources": "Course Resources",
    "ResourceInfo": "Resource Info",
    "EnglishFile": "English File",
    "ArabicFile": "Arabic File",
    "ChooseCourses": "Choose Courses",
    "ResourceFileRequired": "Upload the English file first; it is required.",
    "ResourceCoursesRequired": "Choose at least one course.",
    "ResourceDeleteConfirm": "This resource will be removed from every course it is linked to. Are you sure?",
    "ResourceUploadHint": "PDF, Word, Excel, PowerPoint or ZIP, up to 500 MB",
    "CourseResourcesLead": "Files students see on the course page's Resources tab, when their package includes the Course Resources feature.",
    "ResourceDetails": "Resource details",
    "ResourceFiles": "Files",
    "ResourceFileAr": "Arabic",
    "ResourceFileEn": "English",
    "ResourceCoursesEditHint": "To change the courses, use the Courses button in the table.",
    "Optional": "optional",
    "OpenFile": "Open file",
    "RemoveFile": "Remove file",
    "ResourceDropHere": "Drag the file here or click to choose it",
    "ResourceReplaceFile": "Drag another file or click to replace it",
    "ResourceUploading": "Uploading… {{percent}}%",
    "ResourceUploadFailed": "The file couldn't be uploaded. Try again.",
    "ResourceBadType": "Unsupported file type. Allowed: PDF, Word, Excel, PowerPoint or ZIP.",
    "ResourceTooLarge": "The file is larger than 500 MB.",
    "TheAnswerOfRequirment": "The answer of this requirement",
    "SearchOptions": "Search in options",
    "Length": "Length",
    "PolicyInfo": "Policy Info",
    "Policy": "Policy",
    "IAgreeOnPackagePolicy": "I agree on policy of this package",
    "EnglishTransition": "English Transition",
    "ArabicTransition": "Arabic Transition",
    "PackagesPolicies": "Packages Policies",
    "UsersPerformances": "Users Performance",
    "Whatsapp": "Whatsapp",
    "Notes": "Notes",
    "EnglishContent": "English Content",
    "ArabicContent": "Arabic Content",
    "AddLink": "Add Link",
    "LinkCopied": "Link Copied",
    "SendingEmailsText": "Sending..., this process may take few minutes",
    "SendingEmailsError": "Error happend while sending some results",
    "SendingEmailsFinish": "Sending process has been finished successfully",
    "RUN_PARENT_EXAM": "This type of exams cannot be run, please contact the website admin",
    "PackagesCategories": "Packages Categories",
    "NoLink": "Link cannot be generated",
    "LinkIsCopied": "Link is copied to your clipboard",
    "OverallPerformance": "Overall Performance",
    "IncludeFields": "Include Fields",
    "Companies": "Companies",
    "Hide": "Hide",
    "GoldenCert2": "ACCA Exam Preparation Course (Coming Soon)",
    "CompaniesReport": "Companies Report",
    "CompanySize": "Company Size",
    "JobTitle": "Job Title",
    "JobLevel": "Job Level",
    "TrainNeeds": "Train Needs",
    "AdminNotes": "Admin Notes",
    "Employees": "Employees",
    "Small": "Small",
    "Medium": "Medium",
    "Enterprise": "Enterprise",
    "Entry": "Entry Level",
    "Mid": "Mid Level",
    "Senior": "Senior",
    "Manager": "Manager",
    "CompaniesCourses": "Companies Courses",
    "Initial": "Initial",
    "ExpireOn": "Expire On",
    "FREE": "Free",
    "PAID": "Paid",
    "DEMO": "Demo",
    "TOP_SELL": "Top Seller",
    "PREFERRED": "Most Preferred",
    "GOLD_PROMIS": "Golder Promise",
    "SILVER_PROMIS": "Silver Promise",
    "CONT_PROMIS": "Continuous Promise",
    "Uploaded": "Uploaded",
    "Ready": "Ready",
    "Badge": "Badge",
    "Badges": "Badges",
    "UserBadges": "Users Badges",
    "UserBadge": "User Badge",
    "UserBadgeInfo": "User Badge Info",
    "BadgeInfo": "Badge Info",
    "UserCertAttendanceInfo": "User Certificate Attendance Info",
    "CertAttendance": "Certificate Attendance",
    "CertsAttendance": "Certificates Attendance",
    "CertAttendanceInfo": "Certificate Attendance Info",
    "UserCertAttendance": "User Certificate Attendance",
    "UserCertsAttendance": "Users Certificates Attendance",
    "EnglishUsername": "English Username",
    "ArabicUsername": "Arabic Username",
    "BadgesAndAttendance": "Badges & Attendance",
    "DUPLICATE_ENTRY": "This entry is already existed",
    "EnglishCertAttendance": "English Certificate Attendance",
    "ArabicCertAttendance": "Arabic Certificate Attendance",
    "LandingBadgesText": "Join Learning-Go Now and Get Your Own Certificate",
    "Provider": "Provider",
    "ExpirationDate": "Expiration Date",
    "IssueDate": "Issue Date",
    "Recipient": "Recipient",
    "DoesNotExpire": "Does not Expire",
    "Learning-Go": "Learning-Go",
    "GenerateBadge&Attendance": "Generate Badge & Certificate Attendance",
    "Download": "Download",
    "Completed": "Completed",
    "BADGE_LIMIT_EXCEED": "Badge is already existed",
    "BADGE_COND_FAILED": "You did not match the conditions yet",
    "BADGE_SUBSCR_MISSED": "Your Subscription does not have this feature",
    "CERT_ATTEND_LIMIT_EXCEED": "Certificate is already existed",
    "CERT_ATTEND_COND_FAILED": "You did not match the conditions yet",
    "CERT_ATTEND_SUBSCR_MISSED": "Your Subscription does not have this feature",
    "Copy": "Copy",
    "BadgeBlockText": "Congratulations {{user}} for completing {{course}}!",
    "GeneratFailed": "Generating Failed",
    "ResetExams": "Reset Exam",
    "UpdatedAt": "Updated At",
    "UpdatedBy": "Updated By",
    "Sector": "Sector",
    "Software": "Software",
    "Education": "Education",
    "Financial": "Financial",
    "Representatives": "Representatives",
    "Representative": "Representative",
    "Proposals": "Proposals",
    "Proposal": "Proposal",
    "Company": "Company",
    "Orders": "Orders",
    "Participants": "Participants",
    "TrainMode": "Training Mode",
    "Sessions": "Sessions",
    "Budget": "Budget",
    "HearAboutUs": "Hear About Us",
    "NeedCustomize": "Need Customization",
    "TheCode": "Code",
    "Private": "Private",
    "Present": "Present",
    "Online": "Online",
    "Registered": "Registered",
    "Mix": "Mix",
    "En_En": "English-English",
    "En_Ar": "English-Arabic",
    "Ar_Ar": "Arabic-Arabic",
    "Worksheets": "Worksheets",
    "Document": "Document",
    "Links": "Links",
    "Process": "Process",
    "Contact": "Contact",
    "Meet": "Meet",
    "PrepareOffer": "Prepare Offer",
    "SendOffer": "Send Offer",
    "ModifyOffer": "Modify Offer",
    "StartCourse": "Start Course",
    "CollectCash": "Collect Cash",
    "BuisnessCertification": "Business Certificate Course",
    "BuisnessProfCourse": "Business Professional Course",
    "BusinessRequests": "Business Requests",
    "CiaMakeSureScrollDown": "Make sure you view all the information by scrolling down.",
    "InvisibleContent": "Invisible Content",
    "MarkFlag": "Mark question for review",
    "ReviewAll": "Review All",
    "ReviewUnAttempted": "Review Unattempted",
    "ReviewNotAttempted": "Review Not Attempted",
    "ReviewFlagged": "Review Flagged",
    "Instructions": "Instructions",
    "CiaSummaryInstructionsText1": "Below is a summary of all your answers. You can review your questions in three different ways.",
    "CiaSummaryInstructionsText2": "The keys in the corner at the bottom contain these options:",
    "CiaSummaryInstructionsText3": "Review all questions - Click to review all questions and answers.",
    "CiaSummaryInstructionsText4": "Review incomplete questions - Click to review questions that were left incomplete.",
    "CiaSummaryInstructionsText5": "Review flagged items - Click to review questions that have been flagged for review (click the flag icon to change the flag status for review).",
    "CiaSummaryInstructionsText6": "When you're finished reviewing, you can click the Finish button. Clicking the Finish button will exit the exam and begin completing the questionnaire. Important: Once you've finished reviewing, you won't be able to return to this or any previous screen.",
    "ClickNextToStartReview": "Click next to start review",
    "StartReview": "Start Review",
    "All": "All",
    "CiaFinishExam": "Once you have finised your review, you will not be able to return to the exam.",
    "CiaFinishExamUnattempted": "You have chosen to end the current review, but there are {{count}} incomplete questions. If you click Yes, you will not be able to return to this review.",
    "ExamReview": "Exam Review",
    "ShowFact": "Show Essay Scenario",
    "HideFact": "Hide Essay Scenario",
    "CmaTutorialPage1Text1": "CMA Exam Simulation",
    "CmaTutorialPage1Text2": "Exam Structure",
    "CmaTutorialPage1Text3": "This CMA Exam Simulation contains:",
    "CmaTutorialPage1Text4": "100 multiple-choice questions presented in one (1) content section. You will have 180 minutes to complete the exam.",
    "CmaTutorialPage1Text5": "2 essay questions presented in two (2) content section. You will have 60 minutes to complete the exam.",
    "CmaTutorialPage1Text6": "Please note that the purpose of this Exam Simulation is to give you a sense of the experience of the exam as it will be in the test center.",
    "CmaTutorialPage1Text7": "Please note that for the CMA certification exam, you will have 2 content sections, and you will have 4 hours to complete both sections. The first (1) content section will be multiple-choice and you will have 3 hours to complete that section. You must answer at least 50% of the multiple-choice questions correctly to continue to the essay sections of the exam. The second (2) content section will contain two essays and related questions. There will be a post-exam survey in the CMA certification exam.",
    "CmaTutorialPage1Text8": "Before you begin, it is strongly recommended that you take a few minutes to review the tutorial before attempting any exam questions. The tutorial provides an overview of the features available to you during the examination.",
    "CmaTutorialPage1Text9": "Please note, clicking on the 'Finish Test' button and selecting 'Finish Exam' at any point during the examination will end the entire exam. Any questions that are incomplete will be marked as incorrect.",
    "CmaTutorialPage2Text1": "Welcome to the Tutorial",
    "CmaTutorialPage2Text2": "This tutorial provides a series of screens that orient you to the computer testing environment. You will be instructed on how to use the mouse and the different parts of the screen.",
    "CmaTutorialPage2Text3": "Notice the timer at the top of the screen. A similar display will appear during the actual exam. To the left of the screen is a numbered list that shows you where you are in the series of examination questions (or in this case, screens of the tutorial). Other screen features are described later in the tutorial.",
    "CmaTutorialPage2Text4": "Click the 'Next' button to continue.",
    "CmaTutorialPage3Text1": "Using the Mouse",
    "CmaTutorialPage3Text2": "The mouse pointer moves when you move the mouse around on a surface. Although it can assume different shapes, the arrow shown above is most common. To point with the mouse, move the pointer until it rests on the desired object. To click on an object, point to it and then quickly press and release the left mouse button.",
    "CmaTutorialPage3Text3": "Click the 'Next' button to continue.",
    "CmaTutorialPage4Text1": "Navigating Through the Exam",
    "CmaTutorialPage4Text2": "Click the Next button displayed at the bottom of the screen to move to the next screen or question. Click the Back button to move to the previous screen or question.",
    "CmaTutorialPage4Text3": "In addition to the navigation buttons, you can use the numbered buttons displayed on the left side of the screen. Depending on the number of questions in the section, you may need to click on the down arrow to navigate to additional questions.",
    "CmaTutorialPage4Text4": "The numbered buttons change appearance to indicate different question states: Current, Attempted, Unattempted, and Flagged.",
    "CmaTutorialPage4Text5": "The current question will be indicated by an arrow-shaped numbered button.",
    "CmaTutorialPage4Text6": "For all attempted questions, the numbered button will appear darker in color.",
    "CmaTutorialPage4Text7": "For all unattempted questions, the numbered button will remain the original color.",
    "CmaTutorialPage4Text8": "Flagged questions will show a flag icon on the numbered button.",
    "CmaTutorialPage4Text9": "Click the 'Next' button to continue.",
    "CmaTutorialPage5Text1": "Using the Scroll Function",
    "CmaTutorialPage5Text2": "When a question does not fit on a single screen, the following warning will appear at the bottom of the screen.",
    "CmaTutorialPage5Text3": "To scroll through the screen contents, click and drag the scroll bar as necessary or use the scroll wheel on the mouse.",
    "CmaTutorialPage5Text4": "Click the 'Next' button to continue.",
    "CmaTutorialPage6Text1": "Time Remaining",
    "CmaTutorialPage6Text2": "The amount of time remaining is displayed at the top of the screen.",
    "CmaTutorialPage6Text3": "Each section of this examination is allocated a specific amount of time, including the Tutorial. There is also an overall amount of time provided for your full exam appointment. Clicking on the clock will switch between the amount of time remaining in the current section of the exam and the amount of time remaining in all content sections, if applicable.",
    "CmaTutorialPage6Text4": "The most important time display for you as a test taker is the 'Section Time Remaining.'",
    "CmaTutorialPage6Text5": "Note that, where applicable, an alert box will appear below the exam clock to signal when 30 minutes, 15 minutes, and 5 minutes remain in the current section.",
    "CmaTutorialPage6Text6": "Click the 'Next' button to continue.",
    "CmaTutorialPage7Text1": "Flagging Questions",
    "CmaTutorialPage7Text2": "You can flag a question as a reminder to go back and check your answer or attempt it later.",
    "CmaTutorialPage7Text3": "To flag a question, click the Flag button displayed at the bottom of the exam screen.",
    "CmaTutorialPage7Text4": "Any questions that are flagged for review will show a flag icon on the numbered button, as shown below. Click the Flag button again to remove the flag.",
    "CmaTutorialPage7Text5": "Click the 'Next' button to continue.",
    "CmaTutorialPage8Text1": "Answering Multiple-Choice Questions",
    "CmaTutorialPage8Text2": "This examination uses multiple-choice questions. This type of question has one correct answer.",
    "CmaTutorialPage8Text3": "To complete each multiple-choice question, click on the option that you believe to be the single best answer. Once selected, the option will appear darker in color. To change your response, click on a different option. If you would like to unselect a chosen option, click on it a second time.",
    "CmaTutorialPage8Text4": "Practice answering the multiple-choice question below. Once you have finished practicing, click the 'Next' button to continue.",
    "CmaTutorialPage8Text5": "Of the following biological levels of organization, which represents the smallest or lowest level?",
    "CmaTutorialPage8Text6": "ecosystem",
    "CmaTutorialPage8Text7": "cell",
    "CmaTutorialPage8Text8": "population",
    "CmaTutorialPage8Text9": "organism",
    "CmaTutorialPage9Text1": "Using the Calculator",
    "CmaTutorialPage9Text2": "A calculator is available for your use on every item in the exam. This calculator is similar to the calculator found in Microsoft Windows.",
    "CmaTutorialPage9Text3": "You can use the calculator to perform any of the standard operations for which you would normally use a handheld calculator. The calculator performs basic arithmetic, such as addition, subtraction, multiplication, and division.",
    "CmaTutorialPage9Text4": "Click the 'Next' button to continue.",
    "CmaTutorialPage10Text1": "highlighting Text",
    "CmaTutorialPage10Text2": "During the examination, you will be able to highlight question text that you feel is important to refer back to as you progress through the exam. The highlight will remain present as you navigate through the exam, unless you select to remove it.",
    "CmaTutorialPage10Text3": "To highlight text, click and drag the mouse cursor over the desired text. Click the Highlight button, as shown in the image below, that appears after releasing the mouse button. To remove, click on any area of the highlighted text and click the Highlight button again.",
    "CmaTutorialPage10Text4": "The highlight feature cannot be applied to text within the answer options.",
    "CmaTutorialPage10Text5": "Click the 'Next' button to continue.",
    "CmaTutorialPage11Text1": "Striking Out Options",
    "CmaTutorialPage11Text2": "During the examination, a Strikeout feature is available to help you visually eliminate possible options from consideration. A struck out option will remain present as you progress through the exam, unless you select to remove it.",
    "CmaTutorialPage11Text3": "Right-click on an option to strike it out. Right-click again to remove the strikeout. Left-click on a struck out option to select it as your response. You may strike out as many or as few items as you like.",
    "CmaTutorialPage11Text4": "Practice using the Strikeout feature below. Once you have finished practicing, click the 'Next' button to continue.",
    "CmaTutorialPage11Text5": "How many lungs does the typical human body have?",
    "CmaTutorialPage11Text6": "One",
    "CmaTutorialPage11Text7": "Two",
    "CmaTutorialPage11Text8": "Three",
    "CmaTutorialPage11Text9": "Four",
    "CmaTutorialPage12Text1": "Section Review",
    "CmaTutorialPage12Text2": "During the examination, you can review the status of all questions in a current exam section using the grid icon",
    "CmaTutorialPage12Text3": "located in the bottom left corner of the exam screen.",
    "CmaTutorialPage12Text4": "To navigate directly to a question, click the corresponding numbered icon. You may also filter your view by unattempted, attempted, and flagged questions. The Section Review can be locked in place using the padlock icon and closed using the 'X' icon.",
    "CmaTutorialPage12Text5": "Click the 'Next' button to continue.",
    "CmaTutorialPage13Text1": "Ending the Examination",
    "CmaTutorialPage13Text2": "After completing and reviewing all of the questions, you can end the exam by clicking the 'Finish Test' button in the top-right corner of the screen. Once clicked, a pop-up windows will appear confirming that you want to finish the test. Click on the 'Finish' button to submit your answers.",
    "CmaTutorialPage13Text3": "Selecting the “Finish Test” button during any part of the exam, will terminate the exam.  Once you leave the content section, you may not return. Any questions that are left incomplete will be marked as incorrect",
    "CmaTutorialPage13Text4": "Click the 'Next' button to continue.",
    "CmaTutorialPage14Text1": "Tutorial Conclusion",
    "CmaTutorialPage14Text2": "This concludes the tutorial. You can review the tutorial by clicking on the 'Back' button to back up one screen at a time, or by using the numbered buttons displayed on the left side of the screen. You may view the tutorial at any point during an active examination by clicking on the question mark icon. This icon can be found in the bottom left of the screen once you have begun testing.",
    "CmaTutorialPage14Text3": "Good luck with the examination.",
    "CmaTutorialPage14Text4": "Click the 'Start the Test' button to exit the tutorial and begin the examination.",
    "CMAExamSimulation": "CMA Exam Simulation",
    "FinishTest": "Finish Test",
    "StartTheTest": "Start the Exam",
    "ContinueTheTest": "Countine the Test",
    "MandatoryPassQuestions": "Mandatory Pass Questions",
    "Page": "Page",
    "Test": "Test",
    "Candidate": "Candidate",
    "FinishReview": "Finish Review",
    "Wrong": "Wrong",
    "SectionTimeRemaining": "Section Time Remaining",
    "Banners": "Banners",
    "Banner": "Banner",
    "BannerInfo": "Banner Info",
    "EnglishButton": "English Button",
    "ArabicButton": "Arabic Button",
    "Accredits": "Accredits",
    "Accredit": "Accredit",
    "AccreditInfo": "Accredit Info",
    "AccreditedBy": "Accredited By",
    "QuestionsOrder": "Questions Order",
    "EnglishSource": "English Source",
    "ArabicSource": "Arabic Source",
    "Theory": "Theoretical",
    "Practical": "Practical",
    "Easy": "Easy",
    "Hard": "Hard",
    "Knowledge": "Knowledge",
    "Comprehension": "Comprehension",
    "Application": "Application",
    "Analysis": "Analysis",
    "Synthesis": "Synthesis",
    "Evaluation": "Evaluation",
    "TotalFilteredQuestions": "Total Filtered Questions",
    "CopyPackage": "Copy Package",
    "QuestionConcept": "Question Concept",
    "KnowledgeDesc": "Test the ability to memorize materials",
    "ComprehensionDesc": "Test the ability to understand memorized material",
    "ApplicationDesc": "Test the ability to use learned material in specific situations",
    "AnalysisDesc": "Test the ability to recognize causal relationships. Discriminate between behaviors, and identify elements that support a judgement",
    "SynthesisDesc": "Test the ability to relate ideas and formulate hypotheses",
    "EvaluationDesc": "Test the ability to make judgements and select a course of action",
    "EnglishReadMore": "English Read More",
    "ArabicReadMore": " Arabic Read More",
    "ShowReadMoreAfterFirstBlock": "Show read more option after first block",
    "CpaFinishExamHeader": "You have skipped one or more questions in the testlet",
    "CpaFinishExamText": "Click SUBMIT TESTLET to confirm your submission,or click on question number above to complete your work, You will not be able to return to this testlet after you click SUBMIT TESTLET",
    "ReturnToTestlet": "Return to testlet",
    "Save&Close": "Save & Close",
    "NavigateTo": "Navigate To",
    "Overview": "Overview",
    "CorrectAnswerUnit": "Answer Unit",
    "CalculatedValueInstructions": "Calculated Value Instructions",
    "CalculatedValueInstructionsText1": "You can use 5 primary operations:",
    "CalculatedValueInstructionsText2": "+, -, *, / and ^",
    "CalculatedValueInstructionsText3": "You can use '(' and ')' for priority",
    "CalculatedValueInstructionsText4": "Variables should be the cell index ex: c[1] means the first cell in the table",
    "CalculatedValueInstructionsText5": "Equation Example: ((c[1]+c[2])-c[3])^2",
    "CalculatedValueInstructionsText6": "Don't add any spaces in your equation",
    "ResetPerformance": "Reset Performance",
    "UsePlaceholdersText": "Use the following placeholders in your template to customize results",
    "FactsCount": "Facts Count",
    "EnglishRealName": "English Real Name",
    "ArabicRealName": "Arabic Real Name",
    "PackagesPacks": "Packages Packs",
    "PackInfo": "Pack Info",
    "RequiredUserOrEmail": "User or Emails is Required",
    "RequiredPackOrPackage": "Pack or Package is Required",
    "RelatedCoursesOptions": "Related Courses Options",
    "PdfToggleSidebar": "Toggle Sidebar",
    "PdfFind": "Find",
    "PdfPreviousPage": "Previous Page",
    "PdfNextPage": "Next Page",
    "PdfPage": "Page",
    "PdfOf": "of",
    "PdfZoomOut": "Zoom Out",
    "PdfZoomIn": "Zoom In",
    "PdfAutomaticZoom": "Automatic Zoom",
    "PdfActualSize": "Actual Size",
    "PdfPageFit": "Page Fit",
    "PdfPageWidth": "Page Width",
    "PdfHighlightText": "Highlight Text",
    "PdfHighlightColor": "Highlight Color",
    "PdfYellow": "Yellow",
    "PdfGreen": "Green",
    "PdfPink": "Pink",
    "PdfBlue": "Blue",
    "PdfRemoveHighlight": "Remove Highlight",
    "PdfStrikethroughText": "Strikethrough Text",
    "PdfTools": "Tools",
    "PdfGoToFirstPage": "Go to First Page",
    "PdfGoToLastPage": "Go to Last Page",
    "PdfRotateClockwise": "Rotate Clockwise",
    "PdfRotateAntiClockwise": "Rotate Anti-Clockwise",
    "PdfTextSelectionTool": "Text Selection Tool",
    "PdfHandTool": "Hand Tool",
    "PdfDocumentProperties": "Document Properties...",
    "PdfSearchInDocument": "Search in document...",
    "PdfNoMatches": "No matches",
    "PdfPrevious": "Previous (Shift+Enter)",
    "PdfNext": "Next (Enter)",
    "PdfHighlightAll": "Highlight all",
    "PdfMatchCase": "Match case",
    "PdfClose": "Close",
    "PdfErrorLoad": "Couldn't display the file — it may be damaged, or there may be an internet connection problem. Please try again.",
    "Of": "of",
    "SymbolCopied": "Your chosen symbol has been copied, you can paste it anywhere you want.",
    "ItemReviewScreenExplained": "Item Review Screen Explained",
    "ExamSection": "Exam Section",
    "ItemReviewScreen": "Item Review Screen",
    "ItemReviewScreenText1": "This screen shows the flag status of each question plus the following question states:",
    "ItemReviewScreenText2": "Attempted - you have attempted the question.",
    "ItemReviewScreenText3": "Not attempted - you have viewed the question but not attempted it.",
    "ItemReviewScreenText4": "Unseen - you have not yet viewed the question.",
    "ItemReviewScreenText5": "There will be no indication on whether the answers you have provided are correct or incorrect. You should refer to the solution material for guidance to assess your own performance.",
    "ItemReviewScreenText6": "You can select individual questions for review by clicking on the question number.",
    "ItemReviewScreenText7": "You can also use the buttons at the bottom of the screen to quickly review groups of questions.",
    "ItemReviewScreenText8": "During your review you can change answers or the flag status of questions, and when you revisit the item Review Screen, any status updates will be shown.",
    "DifrFinishExamUnattempted": "You have chosen to end the current review, but there are {{count}} incomplete questions. If you click Yes, you will not be able to return to this review.",
    "DifrFinishExamText1": "You have chosen to end this exam, If you continue, you will NOT be able to return to this exam.",
    "DifrFinishExamText2": "Are you sure you want to end this exam?",
    "EndExam": "End Exam",
    "DifrTutorialPage1Text1": "Instructions (1 of 4)",
    "DifrTutorialPage1Text2": "The instructions below are representative of those presented in the live test. Any differences between this test and the live test will be explained. ",
    "DifrTutorialPage1Text3": "General Instructions",
    "DifrTutorialPage1Text4": "In this test, as in the actual test, the instruction screens will be available for a maximum of 10 minutes before the test begins.",
    "DifrTutorialPage1Text5": "The specified test time will start automatically after the 10-minute period has elapsed (or earlier if you choose to start the test during the 10-minute period). ",
    "DifrTutorialPage1Text6": "You can access a copy of the instruction screens at any time during the test by clicking the 'Help' button provided.",
    "DifrTutorialPage1Text7": "The Workspace",
    "DifrTutorialPage1Text8": "Your test consists of a number of questions. Each question is displayed in a workspace. Each workspace will include:",
    "DifrTutorialPage1Text9": "Introductory information about the question.",
    "DifrTutorialPage1Text10": "Exhibits - Contains the question scenario content divided into sections or information sources you will need to answer the question requirements.",
    "DifrTutorialPage1Text11": "Requirements - Lists the requirements to be completed in the workspace.",
    "DifrTutorialPage1Text12": "Response Options - You will be presented with one or more word",
    "DifrTutorialPage1Text13": "processing and/or spreadsheet options to create your answer.",
    "DifrTutorialPage1Text14": "When selected, items, requirements, and response options will appear in windows that can be moved and resized as needed.",
    "DifrTutorialPage1Text15": "You can close each window individually or all windows at once by selecting the x.",
    "DifrTutorialPage1Text16": "Close all appears in the top toolbar. This minimizes open windows to the left side of the screen. Any answers you entered will be saved, and you can reopen and change your answers at any time.",
    "DifrTutorialPage1Text17": "There is a splitter bar which can be used for you to see more or less of the left or right hand side of the screen, as required.",
    "DifrTutorialPage1Text18": "You can highlight or strikethrough text in the introductory information, PDF exhibits or requirements by selecting Highlight or Strikethrough.",
    "DifrTutorialPage1Text19": "You can copy and paste between exhibits, requirements and response options by using the Ctrl-C (Copy) and Ctrl-V (Paste) shortcuts. Note: When pasting into a spreadsheet in the live exam you must",
    "DifrTutorialPage1Text20": "double-click the cell or paste directly into the formula bar. In this exam you must paste into the spreadsheet by selecting the cell.",
    "DifrTutorialPage2Text1": "Instructions (2 of 4)",
    "DifrTutorialPage2Text2": "Navigation",
    "DifrTutorialPage2Text3": "The question number you are viewing is displayed in the top display bar. You can hide or restore this display by selecting <icon />",
    "DifrTutorialPage2Text4": "You can navigate between screens by selecting <icon1/> or <icon2/> or by clicking on a question number from the Navigator or Item Review screens.",
    "DifrTutorialPage2Text5": "You can revisit questions and change your answer at any time during the exam.",
    "DifrTutorialPage2Text6": "Flag for Review",
    "DifrTutorialPage2Text7": "If you wish to revisit/review a question later in the exam, click <icon/> Flag for Review.",
    "DifrTutorialPage2Text8": "Click the button again to remove the flag.",
    "DifrTutorialPage2Text9": "Help",
    "DifrTutorialPage2Text10": "Click the Help button provided to access:",
    "DifrTutorialPage2Text11": "A copy of these exam instructions.",
    "DifrTutorialPage2Text12": "Help and guidance on workspace",
    "DifrTutorialPage2Text13": "Formulae sheets/tax tables if your exam requires these. Note that the name of the Help button will indicate if formulae sheets/tax tables are available i.e. <icon/>.",
    "DifrTutorialPage2Text14": "Calculator",
    "DifrTutorialPage2Text15": "You have the option to use the on-screen standard calculator by selecting <icon/>.",
    "DifrTutorialPage2Text16": "Note that in the live exam you are also permitted to use your own calculator providing it does not have the facility to store or display text.",
    "DifrTutorialPage3Text1": "Instructions (3 of 4)",
    "DifrTutorialPage3Text2": "Workings/Scratch Pad",
    "DifrTutorialPage3Text3": "You may use an on-screen Scratch Pad to make notes/workings by selecting <icon/>.",
    "DifrTutorialPage3Text4": "You can cut and copy text from the Scratch Pad and paste into your response options either by using the Ctrl-C (Copy), Ctrl-X (Cut) and Ctrl-V (Paste) shortcuts, or the on-screen buttons.",
    "DifrTutorialPage3Text5": "The Scratch Pad retains all notes/workings entered for all workspaces and these are available for the duration of the exam. They will not be submitted for marking after your live exam.",
    "DifrTutorialPage3Text6": "You will also be provided with paper for notes/workings for your live exam, should be prefer to use it. This will not be submitted for marking. It will be collected at the end of the exam and must not be removed from the exam room.",
    "DifrTutorialPage3Text7": "Important:",
    "DifrTutorialPage3Text8": "The notes/workings entered onto the Scratch Pad or your workings paper during the live exam will not be marked.",
    "DifrTutorialPage3Text9": "If you want the marker to see any notes/workings for question requirements in the live exam you must show them within the relevant response options.",
    "DifrTutorialPage3Text10": "Symbol",
    "DifrTutorialPage3Text11": "You can add a selection of currency symbols to your answers by selecting <icon/> on the top toolbar.",
    "DifrTutorialPage3Text12": "Navigator Screen",
    "DifrTutorialPage3Text13": "Navigator can be accessed at any time during the exam by selecting <icon/>.",
    "DifrTutorialPage3Text14": "This screen allows you to jump to any question number in the exam.",
    "DifrTutorialPage3Text15": "It also allow you to see the status of each question and whether it has been viewed, attempted or flagged for review.",
    "DifrTutorialPage4Text1": "Instructions (4 of 4)",
    "DifrTutorialPage4Text2": "Reviewing the Exam",
    "DifrTutorialPage4Text3": "You can review this exam once you have attempted any, or all, of the questions.",
    "DifrTutorialPage4Text4": "To do this:",
    "DifrTutorialPage4Text5": "Navigate to the last question in the exam.",
    "DifrTutorialPage4Text6": "Click <icon/>.",
    "DifrTutorialPage4Text7": "This takes you to the Item Review screen.",
    "DifrTutorialPage4Text8": "Item Review Screen",
    "DifrTutorialPage4Text9": "This screen gives you an opportunity to see the flag and attempted status of all questions and to review your answers before you finally exit the exam.",
    "DifrTutorialPage4Text10": "You can select individual questions you wish to revisit, or quickly access groups of questions from the Item Review screen.",
    "DifrTutorialPage4Text11": "During the item review period Navigator is not available however you can navigate to questions by selecting Next <icon1/>, <icon2/> Previous or <icon3/> Review Screen.",
    "DifrTutorialPage4Text12": "When reviewing questions you can change your answer and click Review Screen to view any updated status on the Item Review screen.",
    "DifrTutorialPage4Text13": "You can review your answers against the relevant solution material provided in the platform",
    "DifrTutorialPage4Text14": "Ending the Exam",
    "DifrTutorialPage4Text15": "Once you have completed your item review and wish to finally end the exam click End Exam from the Item Review screen.",
    "DifrTutorialPage4Text16": "Once you end the exam, you cannot revisit any questions.",
    "DifrTutorialPage4Text17": "Select Next to move to the Exam Summary screen.",
    "DifrTutorialPage5Text1": "Exam Summary",
    "DifrTutorialPage5Text2": "Time allowed: This sample exam is timed.",
    "DifrTutorialPage5Text3": "This exam contains 4 questions worth 25 marks each.",
    "DifrTutorialPage5Text4": "100 marks in total.",
    "DifrTutorialPage5Text5": "All questions are compulsory.",
    "DifrTutorialPage5Text6": "Important:",
    "DifrTutorialPage5Text7": "In your live exam, you should:",
    "DifrTutorialPage5Text8": "Enter your answer for each question in the response options provided for that question. Any answers entered into a response options provided for a different question will not be marked.",
    "DifrTutorialPage5Text9": "Indicate which requirement each of your responses relate to so that this is clear for markers.",
    "DifrTutorialPage5Text10": "Show all notes/workings that you want the marker to see within your responses. Remember, any notes/workings made on the Scratch Pad or on you workings paper will not be marked.",
    "DifrTutorialPage5Text11": "Click Next to start your exam.",
    "WorkspaceHelp": "Workspace Help",
    "ExamInstructions": "Exam Instructions",
    "DifrUnseenContent": "Unseen Content",
    "DifrUnseenContentText1": "You have not yet viewed the entire screen.",
    "DifrUnseenContentText2": "Please use all scrollbars and/or open any on-screen exhibits before trying again.",
    "ResetPopup.Title": "Reset Confirmation",
    "ResetPopup.reset": "Reset",
    "ResetPopup.Message": "Are you sure you want to reset? Resetting will remove any response you have made on this item and reset back to an unanswered state.",
    "ResetPopup.OK": "OK",
    "ResetPopup.Cancel": "Cancel",
    "ResetPopup.yes": "Yes",
    "ResetPopup.no": "No",
    "PackageReceipt.Title": "Package Delivery Confirmation",
    "PackageReceipt.Message": "Did you receive this subscription package's content?",
    "PackageReceipt.Yes": "Yes, I received it",
    "PackageReceipt.No": "Contact our team",
    "PackageReceipt.AckCheckbox": "I confirm the service is activated and that I can access the content.",
    "AckStatus": "Receipt Status",
    "AckStatus.PENDING": "Pending",
    "AckStatus.SEEN": "Seen",
    "AckStatus.CONFIRMED": "Confirmed",
    "NeedConfirmation": "Requires Receipt Confirmation",
    "Emails": "Emails",
    "CountryCode": "Country Code",
    "Pack": "Pack",
    "Results": "Results",
    "Ranks": "Rank",
    "QATAR": "Qatar",
    "UAE": "UAE",
    "PaymentLead": "Payment Lead",
    "pageDifr": {
      "toolbar": {
        "symbol": "Symbol",
        "highlight": "Highlight",
        "strikethrough": "Strikethrough",
        "calculator": "Calculator",
        "scratchPad": "Scratch Pad",
        "closeAll": "Close All",
        "flag": "Flag",
        "favorite": "Favorite"
      },
      "sidebar": {
        "exhibits": "Exhibits",
        "correctAnswer": "Correct Answer",
        "explanation": "Explanation",
        "requirements": "Requirements",
        "marks": "Marks",
        "responseOptions": "Response Options",
        "wordProcessor": "Word Processor",
        "spreadsheet": "Spreadsheet"
      },
      "modals": {
        "reportProblem": "Report a Problem",
        "scratchPad": "Scratch Pad",
        "calculator": "Calculator",
        "comingSoon": "Coming Soon",
        "symbol": "Symbol",
        "wordProcessor": "Word Processor",
        "spreadsheet": "Spreadsheet",
        "answerOfRequirement": "The answer of this requirement"
      }
    },
    "examFooter": {
      "buttons": {
        "help": "Help",
        "reviewAnswers": "Review Answers",
        "exit": "Exit",
        "endExam": "End Exam",
        "back": "Back",
        "navigator": "Navigator",
        "next": "Next"
      },
      "review": {
        "reviewAll": "Review All",
        "reviewNotAttempted": "Review Not Attempted",
        "reviewFlagged": "Review Flagged"
      },
      "modals": {
        "endExamTitle": "End Exam",
        "unattemptedWarning": "You have chosen to end the current review, but there are {{count}} incomplete questions. If you click Yes, you will not be able to return to this review.",
        "finishText1": "You have chosen to end this exam, If you continue, you will NOT be able to return to this exam.",
        "finishText2": "Are you sure you want to end this exam?",
        "comingSoon": "Coming Soon"
      },
      "common": {
        "yes": "YES",
        "no": "NO"
      },
      "navigator": {
        "title": "Navigator",
        "question": "Question",
        "status": "Status",
        "flagged": "Flagged",
        "attempted": "Attempted",
        "notAttempted": "Not Attempted",
        "unseen": "Unseen"
      },
      "help": {
        "title": "Help",
        "workspaceHelp": "Workspace Help",
        "examInstructions": "Exam Instructions"
      }
    },
    "excelMenu": {
      "edit": {
        "title": "Edit",
        "undo": "Undo",
        "redo": "Redo",
        "cut": "Cut",
        "copy": "Copy",
        "paste": "Paste",
        "pasteSpecial": "Paste Special...",
        "copyFormat": "Copy Cell Format",
        "find": "Find...",
        "replace": "Replace...",
        "selectAll": "Select All"
      },
      "format": {
        "title": "Format",
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "rowHeight": "Row Height",
        "columnWidth": "Column Width",
        "numberFormat": "Number Format"
      }
    },
    "customExcelToolbarItems": {
      "reset": "Reset",
      "cut": "Cut",
      "copy": "Copy",
      "paste": "Paste",
      "numberFormat": "Number Format"
    },
    "excelModals": {
      "common": {
        "ok": "OK",
        "cancel": "Cancel"
      },
      "pasteSpecial": {
        "title": "Paste Special",
        "pasteLabel": "Paste",
        "formulas": "Formulas",
        "values": "Values",
        "formats": "Formats",
        "all": "All"
      },
      "rowHeight": {
        "title": "Row Height",
        "heightLabel": "Height",
        "auto": "Auto",
        "custom": "Custom",
        "pixels": "Pixels"
      },
      "columnWidth": {
        "title": "Column Width",
        "widthLabel": "Width",
        "auto": "Auto",
        "custom": "Custom",
        "pixels": "Pixels"
      }
    },
    "v2": {
      "modal": {
        "close": "Close"
      },
      "checkout": {
        "title": "Complete your subscription",
        "duration": "Subscription length: {{days}} days",
        "code": "Discount code",
        "codePlaceholder": "Enter a code if you have one",
        "applyCode": "Apply",
        "codeApplied": "Discount code applied.",
        "codeNoDiscount": "This code gives no discount on this package.",
        "codeInvalid": "This discount code is not valid.",
        "price": "Price",
        "discount": "Discount",
        "codeDiscount": "Code discount",
        "total": "Total",
        "free": "Free",
        "agree": "I agree to this package's policy",
        "showPolicy": "View the policy",
        "hidePolicy": "Hide the policy",
        "policyLoading": "Loading…",
        "policyEmpty": "No policy text has been added for this package.",
        "secure": "Payment is secure, and your details are encrypted and confidential.",
        "pay": "Continue to payment",
        "confirm": "Confirm subscription",
        "subscriptions": "Subscriptions",
        "back": "Back"
      },
      "student": {
        "nav": {
          "subscriptions": "Subscriptions"
        },
        "menu": {
          "label": "Account menu",
          "profile": "Profile information",
          "language": "Change language",
          "signOut": "Sign out"
        },
        "notifications": {
          "title": "Notifications",
          "latest": "Latest notifications",
          "nothingNew": "No new notifications",
          "nothingNewHint": "Unread notifications will show up here as soon as they arrive.",
          "withCount": "Notifications — {{count}} unread",
          "clearAll": "Clear all",
          "loadMore": "Load more",
          "empty": "No notifications yet.",
          "important": "New notifications",
          "dismiss": "Got it"
        },
        "deck": {
          "previous": "Previous",
          "next": "Next"
        },
        "pagination": {
          "label": "Pages",
          "page": "Page {{page}}",
          "summary": "Showing {{shown}} of {{total}}"
        },
        "home": {
          "metaTitle": "Home | Learning-Go Education",
          "account": "My account"
        },
        "subscriptions": {
          "metaTitle": "Subscriptions | Learning-Go Education",
          "title": "Subscriptions",
          "lead": "See every purchase, your access status, your licences and your invoices in one place.",
          "empty": "There are no packages available right now.",
          "packagesFailed": "The available packages could not be loaded. Refresh the page to try again.",
          "active": "Active",
          "inactive": "Inactive",
          "notSubscribed": "Not subscribed",
          "startsAt": "Starts:",
          "endsAt": "Ends:",
          "duration": "Duration:",
          "days": "{{days}} days",
          "price": "Price:",
          "free": "Free",
          "features": "Features",
          "policies": "Policies",
          "payNow": "Pay now",
          "renew": "Renew subscription",
          "subscribe": "Subscribe now",
          "paid": "✓ Paid ${{amount}}",
          "due": "Due ${{amount}}",
          "loadingDetails": "Loading…",
          "noDetails": "No details have been added for this package."
        },
        "courses": {
          "title": "Continue learning",
          "progress": "Overall progress {{percent}}%",
          "expiresOn": "Ends {{date}}",
          "continue": "Continue studying",
          "empty": "You haven't subscribed to anything yet.",
          "browseCertificates": "Browse certificates"
        },
        "course": {
          "metaTitle": "{{name}} | Learning-Go Education",
          "metaTitleFallback": "Course | Learning-Go Education",
          "loading": "Loading…",
          "noCourse": "We couldn't find this course among your subscriptions.",
          "backToDashboard": "Back to home",
          "actions": {
            "banks": "Practice banks",
            "banksLead": "Practise questions from this bank",
            "periodic": "Periodic exams",
            "periodicLead": "Practise the periodic exams",
            "mock": "Mock exams",
            "mockLead": "Test yourself in a real exam setting"
          },
          "tabs": {
            "label": "Course sections",
            "chapters": "Book chapters",
            "history": "Exam history",
            "performance": "Performance",
            "resources": "Resources"
          },
          "chapters": {
            "title": "Book chapters",
            "lead": "Browse the book's chapters, the topics in each one and your progress through them",
            "empty": "No chapters have been added to this course yet.",
            "percent": "{{percent}}%",
            "done": "Completed",
            "continue": "Continue"
          },
          "history": {
            "title": "Exam history",
            "lead": "Review every exam you have completed, with your results and past attempts.",
            "empty": "You haven't completed an exam in this course yet.",
            "name": "Exam name",
            "startsAt": "Started",
            "endsAt": "Finished",
            "type": "Type",
            "questions": "Questions",
            "grade": "Final grade",
            "result": "Result",
            "more": "More",
            "passed": "Passed",
            "failed": "Failed",
            "pending": "Being marked",
            "summary": "Showing {{shown}} of {{total}} exams",
            "retake": "Retake exam",
            "review": "Review exam",
            "analysis": "Result analysis",
            "retakeWrong": "Questions not answered correctly ({{count}})",
            "retakeFlagged": "Flagged questions ({{count}})",
            "retakeUnanswered": "Unanswered questions ({{count}})"
          },
          "results": {
            "title": "Results report: {{name}}",
            "titleNamed": "Results report: {{name}}",
            "titleFallback": "Exam results report",
            "metaTitle": "{{name}} — results report",
            "breadcrumb": "Result analysis",
            "breadcrumbLabel": "Breadcrumb",
            "notFound": "We couldn't find this exam in your courses.",
            "backToHistory": "Back to exam history",
            "options": "Report options",
            "part": "Section {{number}}",
            "partTyped": "Section {{number}} ({{type}})",
            "reviewExam": "Review the whole exam",
            "chapters": {
              "title": "Performance by chapter",
              "empty": "This exam has no chapter-level results.",
              "unavailable": "The chapter results couldn't be loaded right now. Your overall result isn't affected; try opening the report again later.",
              "chapter": "Chapter {{number}}",
              "ordinals": [
                "one",
                "two",
                "three",
                "four",
                "five",
                "six",
                "seven",
                "eight",
                "nine",
                "ten",
                "eleven",
                "twelve",
                "thirteen",
                "fourteen",
                "fifteen",
                "sixteen",
                "seventeen",
                "eighteen",
                "nineteen",
                "twenty"
              ]
            },
            "bands": {
              "review": "Needs review",
              "average": "Average",
              "good": "Good"
            },
            "overall": {
              "title": "Overall result",
              "scored": "Your grade",
              "passing": "Pass mark",
              "ringLabel": "Result {{percent}}%, {{grade}}"
            },
            "grades": {
              "excellent": "Excellent",
              "veryGood": "Very good",
              "good": "Good",
              "fair": "Fair",
              "weak": "Below the pass mark"
            },
            "distribution": {
              "title": "Answers and questions",
              "total": "Total questions",
              "correct": "Correct answers",
              "flagged": "Flagged questions",
              "unanswered": "Unanswered questions",
              "wrong": "Wrong answers"
            },
            "units": {
              "title": "Unit analysis",
              "empty": "There are no lessons in this chapter.",
              "topic": "Lesson topic",
              "score": "Score",
              "questions": "Questions",
              "wrong": "Wrong",
              "unanswered": "Unanswered",
              "correct": "Correct",
              "more": "More",
              "review": "Review",
              "reviewLabel": "Review the questions on {{topic}}"
            }
          },
          "performance": {
            "title": "Your performance and progress",
            "lead": "Follow your progress through the programme and your results across its chapters and exams.",
            "empty": "There is no performance data for this course yet.",
            "complete": "complete",
            "percentComplete": "{{percent}}% complete",
            "units": "Study units",
            "curriculum": "Curriculum progress",
            "questions": "Question performance",
            "total": "Final total",
            "score": "{{score}} / 100",
            "examRow": "{{name}} — part {{part}}"
          },
          "resources": {
            "title": "Learning resources",
            "lead": "Explore the materials and files that help you understand the content and prepare for the certificate.",
            "empty": "No files have been attached to this course yet.",
            "download": "Download",
            "downloadLabel": "Download {{name}}",
            "size": "{{size}} MB",
            "sizeKb": "{{size}} KB"
          },
          "materials": {
            "empty": "There is nothing in this topic yet.",
            "periodicTitle": "Periodic exams",
            "attempts": "{{parts}} part(s) — attempts {{used}} / {{allowed}}",
            "questions": "{{count}} questions",
            "video": "Video",
            "book": "File",
            "mcq": "Multiple-choice questions",
            "essay": "Essay questions",
            "tbs": "Task-based simulations",
            "file": "File-based simulations"
          }
        },
        "bank": {
          "metaTitle": "{{name}} | Learning-Go Education",
          "results": {
            "title": "{{name}} results report",
            "backToSetup": "Back to test setup"
          },
          "breadcrumbLabel": "Breadcrumb",
          "training": "Training & assessments",
          "create": "Create a custom exam",
          "stepsLabel": "Exam setup steps",
          "stepDone": "completed",
          "questionsCount": "{{count}} questions",
          "steps": {
            "topics": {
              "title": "Choose the exam questions",
              "lead": "Pick a unit and topics",
              "heading": "Step 1 - Choose the exam questions",
              "intro": "Pick the units and topics to include from the {{bank}}."
            },
            "modes": {
              "title": "Choose the question mode",
              "lead": "Set the type, difficulty and status",
              "heading": "Choose the question mode"
            },
            "settings": {
              "title": "Exam settings",
              "lead": "Finish and start",
              "heading": "Number of questions and order"
            }
          },
          "topics": {
            "units": "Choose a unit",
            "selectAll": "Select all",
            "selectAllUnits": "Select the topics of every unit",
            "selectAllTopics": "Select every topic in {{unit}}"
          },
          "modes": {
            "legend": "Question status",
            "unanswered": "Questions not answered before",
            "answered": "Questions answered before",
            "favourite": "Favourite questions",
            "categories": "Categories",
            "difficulties": "Difficulty",
            "concepts": "Question concept",
            "total": "Total filtered questions: {{count}}",
            "counting": "Counting the questions…",
            "theory": "Theory",
            "practical": "Practical",
            "easy": "Easy",
            "medium": "Medium",
            "hard": "Hard",
            "knowledge": "Knowledge",
            "comprehension": "Comprehension",
            "application": "Application",
            "analysis": "Analysis",
            "synthesis": "Synthesis",
            "evaluation": "Evaluation"
          },
          "settings": {
            "summary": "Topics: {{topics}} · Questions: {{questions}} (max: {{max}})",
            "count": "Enter the number of questions you want to review",
            "questions": "questions",
            "increase": "More questions",
            "decrease": "Fewer questions",
            "order": "Question order",
            "standard": "Standard order",
            "standardLead": "Questions in their original order in the curriculum",
            "random": "Random order",
            "randomLead": "Questions shuffled every time you start this exam",
            "name": "Exam name",
            "namePlaceholder": "Enter the exam name…"
          },
          "previous": "Previous",
          "next": "Next",
          "start": "Start your exam",
          "starting": "Starting…"
        },
        "knowledgeTest": {
          "results": {
            "title": "Knowledge test results: {{topic}}",
            "titleFallback": "Knowledge test results",
            "course": "Course",
            "backToCourse": "Back to the course",
            "backToBook": "Back to the book"
          }
        },
        "profile": {
          "metaTitle": "Profile | Learning-Go Education",
          "title": "Profile information",
          "lead": "Review the personal details we have on file",
          "male": "Male",
          "female": "Female",
          "avatarEdit": "Edit profile picture",
          "avatarUploading": "Uploading…",
          "avatarSaved": "Profile picture updated.",
          "avatarFailed": "Couldn't update the picture. Please try again.",
          "avatarType": "Accepted formats: JPG or PNG only.",
          "avatarSize": "The image must be 10 MB or smaller."
        },
        "password": {
          "title": "Change password",
          "lead": "Update your account security",
          "sending": "Sending…",
          "sent": "We sent a password-change link to {{email}}. Check your inbox."
        },
        "form": {
          "personal": {
            "title": "Personal information",
            "lead": "The personal details we have on file."
          },
          "contact": {
            "title": "Contact information",
            "lead": "How we get in touch with you."
          },
          "account": {
            "title": "Account actions",
            "lead": "Manage access to your account and your data."
          },
          "firstName": "First name",
          "lastName": "Family name",
          "email": "Email address",
          "phone": "Phone number",
          "signOut": {
            "title": "Sign out",
            "lead": "Sign out of your account on this device."
          },
          "support": {
            "title": "Change account information",
            "lead": "Need to change your account details? Get in touch with support and we will update them for you, safely and quickly.",
            "action": "Contact support"
          }
        }
      },
      "auth": {
        "common": {
          "or": "Or",
          "backToSignin": "Back to login"
        },
        "fields": {
          "mobile": "Mobile number",
          "firstName": "First name",
          "lastName": "Family name",
          "email": "Email address",
          "password": "Password",
          "confirmPassword": "Confirm password",
          "country": "Country",
          "gender": "Gender",
          "male": "Male",
          "female": "Female",
          "enterHere": "Enter here",
          "emailPlaceholder": "Enter your email",
          "passwordPlaceholder": "Enter your password",
          "newPasswordPlaceholder": "Create a strong password",
          "confirmPasswordPlaceholder": "Re-enter your password",
          "countryPlaceholder": "Select a country",
          "countrySearch": "Search for a country",
          "showPassword": "Show password",
          "hidePassword": "Hide password"
        },
        "social": {
          "google": "Continue with Google",
          "apple": "Continue with Apple"
        },
        "signin": {
          "metaTitle": "Login | Learning-Go Education",
          "title": "Log in to your account",
          "lead": "Welcome back! Continue by entering your login details",
          "forgot": "Forgot your password?",
          "submit": "Log in",
          "submitting": "Logging in...",
          "noAccount": "Don't have an account? <signup>Create one</signup>"
        },
        "signup": {
          "metaTitle": "Create an account | Learning-Go Education",
          "title": "Create your free account",
          "lead": "Create your account and start your journey towards the best professional certifications.",
          "submit": "Create account",
          "submitting": "Creating your account...",
          "haveAccount": "Already have an account? <signin>Log in</signin>",
          "consent": "By continuing, you acknowledge that you understand and agree to the <terms>Terms and Conditions</terms> and <privacy>Privacy Policy</privacy>"
        },
        "profile": {
          "metaTitle": "Complete your details | Learning-Go Education",
          "title": "Complete your personal details",
          "lead": "Please fill in your information to create a new account",
          "submit": "Submit"
        },
        "wizard": {
          "progress": "Sign-up steps",
          "personal": "Personal details",
          "contact": "Contact details",
          "security": "Security",
          "next": "Next",
          "previous": "Previous"
        },
        "otp": {
          "metaTitle": "Verification code | Learning-Go Education",
          "title": "Enter the verification code",
          "lead": "We've sent a {{length}}-digit verification code to:",
          "submit": "Verify",
          "submitting": "Verifying...",
          "resend": "Resend the code",
          "resendIn": "Resend in {{countdown}}",
          "changeEmail": "Change email address",
          "changeNumber": "Change mobile number"
        },
        "forgot": {
          "metaTitle": "Forgot password | Learning-Go Education",
          "title": "Forgot your password?",
          "lead": "Enter your email address and we'll send you a link to reset your password.",
          "submit": "Send the link",
          "submitting": "Sending..."
        },
        "checkEmail": {
          "metaTitle": "Check your email | Learning-Go Education",
          "title": "Check your email",
          "lead": "We've sent a password reset link to your email address, {{email}}. Please check your inbox to continue.",
          "leadNoEmail": "We've sent a password reset link to your email address. Please check your inbox to continue.",
          "submit": "Back to login"
        },
        "reset": {
          "metaTitle": "New password | Learning-Go Education",
          "title": "Create a new password",
          "lead": "Choose a strong password for your account, then keep it somewhere safe.",
          "submit": "Save",
          "submitting": "Saving..."
        }
      },
      "nav": {
        "primary": "Primary navigation",
        "home": "Home",
        "curricula": "Curricula",
        "contact": "Contact us",
        "signIn": "Sign in",
        "dashboard": "My account",
        "openMenu": "Open menu",
        "closeMenu": "Close menu"
      },
      "footer": {
        "links": "Links",
        "legal": "Legal",
        "contact": "Contact",
        "contactUs": "Contact us",
        "privacy": "Privacy policy",
        "terms": "Terms and conditions",
        "tagline": "We build the future of professional learning through expert curricula, interactive digital books, and tools that help you understand, practise, and measure progress.",
        "rights": "© {{year}} Learning-Go Education. All rights reserved.",
        "location": "Location"
      },
      "contact": {
        "support": "Support",
        "sales": "Sales",
        "countryCity": "Qatar - Doha",
        "street": "Rawdat Al Khail Street",
        "building": "Zone 52, Building 1",
        "metaTitle": "Contact us — Learning-Go Education",
        "metaDescription": "Reach the Learning-Go Education team or file a complaint. We reply within 24 hours.",
        "pill": "Support centre",
        "title": "Get in touch and get support",
        "lead": "We're here to help. Reach our team or file a complaint — we reply within 24 hours.",
        "tabs": {
          "message": "Contact us",
          "complaint": "File a complaint"
        },
        "message": {
          "title": "Send us a message",
          "lead": "We aim to answer every enquiry within 24 hours.",
          "name": "Full name",
          "namePlaceholder": "Enter your name",
          "email": "Email address",
          "emailPlaceholder": "Enter your email address",
          "phone": "Phone number",
          "phonePlaceholder": "Enter your phone number",
          "body": "Message",
          "bodyPlaceholder": "Write your message here",
          "submit": "Send message",
          "defaultSubject": "Message from the contact page"
        },
        "info": {
          "title": "Contact us",
          "lead": "Our team is ready to help by email, by phone or in person.",
          "email": "Email address",
          "phone": "Phone support",
          "address": "Head office",
          "social": "Find us on"
        },
        "complaint": {
          "title": "File a complaint",
          "lead": "We take your concerns seriously and handle them in complete confidence.",
          "name": "Full name",
          "namePlaceholder": "Enter your full name",
          "phone": "Phone number",
          "phonePlaceholder": "+974 XXXX-XXXX",
          "email": "Email address",
          "emailPlaceholder": "Enter your email address",
          "subject": "Complaint subject",
          "subjectPlaceholder": "For example: week 3 study material missing",
          "details": "Complaint details",
          "detailsPlaceholder": "Please describe what happened in detail...",
          "submit": "Send complaint",
          "commitmentTitle": "Our commitment",
          "commitmentBody": "Learning-Go Education is committed to a fair and transparent learning environment. If something falls short of that standard, please tell us.",
          "stepsTitle": "What happens next",
          "steps": [
            "Your complaint is logged securely.",
            "Reviewed within two working days.",
            "A resolution proposed within five working days."
          ],
          "privacyTitle": "Your privacy is protected",
          "privacyBody": "Every submission is encrypted and read only by authorised staff."
        },
        "attachments": {
          "label": "Attachments (optional, up to {{max}} files)",
          "pick": "Click to upload or drag and drop",
          "hint": "{{formats}} — up to {{megabytes}}MB per file",
          "remove": "Remove {{name}}",
          "tooMany": "You can attach up to {{max}} files.",
          "tooLarge": "Each file must be under {{megabytes}}MB.",
          "badType": "Accepted formats are {{formats}} only."
        },
        "form": {
          "required": "This field is required.",
          "invalidEmail": "Please enter a valid email address.",
          "sending": "Sending...",
          "sent": "We've received your message and will be in touch shortly."
        }
      },
      "social": {
        "facebook": "Facebook",
        "twitter": "X",
        "instagram": "Instagram",
        "youtube": "YouTube",
        "linkedin": "LinkedIn"
      },
      "cta": {
        "title": "Start your learning journey with Learning-⁠Go Education",
        "lead": "Whether you are an individual learner or an institution, you will find the right fit in one integrated platform.",
        "explore": "Explore the curricula",
        "contact": "Contact us"
      },
      "accredited": {
        "pill": "Accredited quality standards",
        "title": "Accredited by",
        "lead": "Our partnerships with leading institutes and global professional bodies keep your material accredited and continuously updated, so you pass first time."
      },
      "cert": {
        "nav": {
          "accreditation": "Accreditation",
          "packages": "Packages",
          "about": "About the certification",
          "faq": "FAQ"
        },
        "breadcrumb": "Breadcrumb",
        "sectionNav": "Page sections",
        "notFound": "This certification could not be found.",
        "faqTitle": "Frequently asked questions",
        "hero": {
          "subtitle": "The complete professional certification programme — ({{code}})",
          "cta": "Explore packages"
        },
        "packages": {
          "title": "Packages",
          "partsLabel": "Certification parts",
          "featuresColumn": "Features and services",
          "tableCaption": "A comparison of the available packages and the features each includes",
          "included": "Included",
          "notIncluded": "Not included",
          "subscribe": "Subscribe now",
          "vatNote": "Prices include VAT",
          "price": "${{price}}/{{period}}",
          "perMonth": "month",
          "perYear": "year",
          "perDays": "{{days}} days",
          "free": "Free"
        }
      },
      "legal": {
        "empty": "This page has no published content yet."
      },
      "home": {
        "metaTitle": "Learning-Go Education — one curriculum for professional certificates",
        "metaDescription": "Textbooks and question banks for professional certificates, built for individuals, institutes and training platforms."
      },
      "hero": {
        "title": "One curriculum bringing together the book, the question bank, and a professional digital learning experience.",
        "lead": "Learning-Go Education provides textbooks and question banks for professional certificates, designed for individuals preparing for exams and for institutes and training platforms looking for professional, structured, accreditable material.",
        "cta": "Browse curricula",
        "deviceAlt": "A laptop showing the Learning-Go Education platform, labelled: question bank, interactive book, study progress, practice questions."
      },
      "catalogue": {
        "metaTitle": "Curricula — Learning-Go Education",
        "metaDescription": "Explore the professional books and curricula built to support your learning journey and grow your expertise in accounting and finance.",
        "pill": "Learning-Go Education library",
        "title": "Explore the professional books and curricula",
        "lead": "Discover a range of professional books and curricula designed to support your learning journey and grow your expertise in accounting and finance.",
        "cta": "Browse curricula",
        "curricula": {
          "title": "Our curricula",
          "lead": "Educational editions that help you study the concepts behind each professional certificate in a structured way.",
          "empty": "No curricula have been published yet."
        },
        "card": {
          "subscribe": "Subscribe now",
          "details": "View details"
        }
      },
      "offerings": {
        "pill": "What we offer",
        "title": "Everything you need to prepare for a professional certificate, in one platform",
        "lead": "Learning-Go Education brings together digital books, professional curricula, question banks, trainer material and institutional licences in one modern learning experience for individuals and organisations alike.",
        "items": [
          {
            "title": "Complete curricula",
            "body": "A platform that gathers the digital book, the question bank, practice exams and progress tracking into a single learning experience."
          },
          {
            "title": "Complete preparation packages",
            "body": "Pick the package that fits: a single book, a full curriculum, or a complete preparation programme for the certificate."
          },
          {
            "title": "Professional textbooks",
            "body": "Structured material that explains certificate concepts clearly, with worked examples and diagrams that build a solid understanding."
          }
        ]
      },
      "methodology": {
        "pill": "How content is built",
        "title": "Every curriculum takes a careful journey before it reaches you",
        "lead": "Content is not assembled at random. It moves through stages that begin with analysing the certificate requirements and end with academic review and continuous updates, so the experience keeps pace with the latest professional standards.",
        "assuranceTitle": "Built to the highest professional standards",
        "assuranceLead": "Every Learning-Go Education curriculum is prepared with experts and specialists, against accredited certificate requirements, so the material stays accurate, current and easy to apply.",
        "assurances": [
          "Follows the certificate’s official standards.",
          "Reviewed by experts and specialists.",
          "Updated continuously to match the latest editions.",
          "Connects theory to practical application.",
          "Designed for a complete digital learning experience."
        ],
        "steps": [
          {
            "stage": "Research",
            "title": "Analysing the requirements",
            "body": "Work begins by studying the latest certificate requirements, official references and learning objectives, so the content matches the accredited standards."
          },
          {
            "stage": "Structure",
            "title": "Designing the curriculum",
            "body": "Content is divided into connected units, chapters and learning paths, giving it a logical sequence that is easy to follow."
          },
          {
            "stage": "Authoring",
            "title": "Writing the content",
            "body": "Specialists prepare clear academic material that pairs theory with practical examples, focusing on simplifying complex concepts."
          },
          {
            "stage": "Application",
            "title": "Examples and applications",
            "body": "The content is enriched with real cases and practical applications that connect what is learned to professional practice."
          },
          {
            "stage": "Questions",
            "title": "Building the question bank",
            "body": "Questions are written for every chapter, with explained answers, to measure understanding and build exam readiness."
          },
          {
            "stage": "Review",
            "title": "Academic review",
            "body": "Specialists review the content for accuracy, alignment with the latest standards, and freedom from academic and language errors."
          },
          {
            "stage": "Publishing",
            "title": "Publishing on the platform",
            "body": "Once approved, the content becomes an interactive digital experience with reading, notes, highlighting, search and smart study tools."
          },
          {
            "stage": "Updates",
            "title": "Continuous updates",
            "body": "Books and curricula are refreshed regularly to track any change in certificate requirements, with the latest editions available to everyone."
          }
        ]
      },
      "expertise": {
        "pill": "Experience and reliability",
        "title": "Deep experience, and a learning experience that keeps moving",
        "lead": "Learning-Go Education was built on the practical experience of the Learning-Go platform in designing digital learning solutions, bringing professional content, modern learning technology, and study and training tools together in one place.",
        "claims": {
          "experience": {
            "title": "Experience that carries over",
            "body": "Learning-Go Education did not start from nothing. It grew out of the practical experience Learning-Go gained designing and delivering digital learning."
          },
          "practice": {
            "title": "Content built on practice",
            "body": "Curricula and books were developed around what learners, trainers and institutes actually need, simplifying concepts and tying them to real application."
          },
          "proven": {
            "title": "A platform that has proven itself",
            "body": "Learning-Go Education runs on technology and an interface developed and tested over years, giving a stable experience that is easy to use."
          },
          "evolving": {
            "title": "Always improving",
            "body": "Content and platform are updated regularly to keep pace with certificate requirements and the best of digital learning practice."
          }
        }
      }
    },
    "BookExpandSection": "Expand section {{number}}",
    "BookCollapseSection": "Collapse section {{number}}",
    "LearningSectionMoveUp": "Move section up",
    "LearningSectionMoveDown": "Move section down",
    "InteractiveBookReorderError": "Section order could not be saved. Reload the book and try again.",
    "EditorUploadCustomIcon": "Upload custom icon",
    "EditorUploadedIcon": "Uploaded icon",
    "EditorCustomIconHint": "PNG, JPG, WebP or GIF. Uploads replace the current bullet or insert an inline icon. Image colors are preserved.",
    "EditorDefaultBullet": "Default bullet",
    "InteractiveBookOptionalFilters": "Filter units by certificate and course, or search all units directly by name or rank. Both filters are optional.",
    "InteractiveBookCertificateFilter": "Certificate (optional)",
    "InteractiveBookCourseFilter": "Course (optional)",
    "InteractiveBookAllCertificates": "All certificates",
    "InteractiveBookAllCourses": "All courses",
    "InteractiveBookLinkedUnit": "Unit linked to this chapter",
    "InteractiveBookLinkedTopic": "Topic linked to this section",
    "InteractiveBookSearchNameRank": "Search by name or rank",
    "InteractiveBookLinkParentFirst": "Select a unit for the parent chapter and save it before choosing a topic for this section.",
    "InteractiveBookUnitRequired": "Choose an available unit to link to this chapter.",
    "InteractiveBookTopicRequired": "Choose a topic from the unit linked to this chapter.",
    "InteractiveBookUnitChangeConfirmation": "Changing this chapter’s unit will remove the topic links from its sections. Their content will be kept, but you will need to choose topics from the new unit. Continue?",
    "InteractiveBookLinkLoadError": "Unable to load the available options. Change your search to try again.",
    "BookLinkedCourses": "Linked courses",
    "BookUnlinkedUnit": "Unlinked unit",
    "BookNodeEnabled": "Enabled in the book",
    "BookNodeDisabled": "Disabled",
    "BookSerialNumber": "Serial number",
    "BookDoneReading": "Done reading",
    "BookMarkUnread": "Mark as unread",
    "BookManualProgressError": "Reading progress could not be saved. Please try again.",
    "BookLinkHierarchy": "Link hierarchy",
    "BookSectionType": "Section type",
    "BookSectionContent": "Content",
    "BookSectionExam": "Exam",
    "BookSectionExamClearsContent": "Exam sections show the mapped topic's tests only. Saving removes this section's English and Arabic content.",
    "BookSharedContentHint": "This book can serve multiple courses. Content edits affect all linked courses; mappings and progress are separate.",
    "BookLinkCourse": "Link a course",
    "BookAssignmentActive": "Use as the course book (uncheck to unlink)",
    "BookReplacePrimary": "Replace this course’s current book",
    "BookMappingHint": "Map every chapter and section before activating. Unlinking preserves student records.",
    "BookCourseLoadError": "Could not load linked courses.",
    "BookCourseSaveError": "Could not save the course links. Check the selected units and topics.",
    "BookCourseInvalid": "Invalid course mapping.",
    "BookMappingsIncomplete": "Map every chapter and section before activating this book.",
    "BookCourseAlreadyLinked": "This course already has a book. Select Replace current book to change it.",
    "BookImport": "Import Interactive Book",
    "BookExport": "Export",
    "BookExportTitle": "Export Interactive Book",
    "BookExportIncludeMedia": "Include media files",
    "BookExportMediaHint": "Embeds server-stored images and audio in the export. External media remains linked by URL, and the file may be much larger.",
    "BookImportInvalidFile": "Choose a valid Interactive Book JSON export (maximum 150 MB).",
    "BookImportError": "The Interactive Book could not be imported.",
    "BookExportError": "The Interactive Book could not be exported.",
    "BookExportMediaError": "The book media could not be embedded. Check that its stored files are available and within the size limits.",
    "BookImportMediaError": "The embedded media could not be stored on the server.",
    "BookDuplicate": "Duplicate Interactive Book",
    "BookCopySuffix": "Copy",
    "BookDuplicateHint": "Creates an independent draft with the saved content. Student records and course assignments are not copied.",
    "BookDuplicateError": "Could not duplicate the book. Try again.",
    "BookNotAvailable": "No published book is available for this course and your subscription.",
    "BookChooseCourse": "Open this book from the course you want to study.",
    "BookOpenFromCourse": "Open the book from your course.",
    "BookBackToCourse": "Back to course",
    "BookShowPages": "View book pages",
    "BookPagesTitle": "Book pages",
    "BookPagesAll": "All",
    "BookPagesSaved": "Saved",
    "BookPagesFilters": "Filter book pages",
    "BookPagesLoading": "Loading pages…",
    "BookPagesEmpty": "No pages match this filter.",
    "BookOpenPage": "Open page {{number}}: {{title}}",
    "BookProgressRetry": "Reading progress could not be saved. Retry, then read this section again.",
    "BookChapterProgress": "Chapter progress: {{percent}}%",
    "BookCourseProgress": "Course progress: {{percent}}%",
    "BookReadingProgressHint": "Use Done reading after finishing a section. You can mark it as unread later.",
    "BookAdditionalMaterials": "Videos and practice by topic",
    "BookReadingNotStarted": "Start reading this section before completing it.",
    "BookCopyReuse": "Reuse the same book",
    "BookCopyIndependent": "Create an independent book copy"
  }
}
